<template>
  <div class="trade-page page-padding-top">
    <div class="top-tab" v-if="!isModal && !hideTopBar">
			{{$t(`trade.title${pageType}`)}}
    </div>

		<div class="trade-main">
			<div class="flex-center-between bit-info">
				<div class="flex-center">
					<img :src="bitUrl" alt="">
					<span class="name" @click="changeBit">{{bitInfo.ShortName}}/USDT</span>
					<span class="percent" :class="bitInfo.percent > 0 ? 'green' : 'red'">{{bitInfo.percent > 0 ? '+' : ''}}{{bitInfo.percent}}%</span>
				</div>
				<div class="more">
					<img :src="moreUrl" class="trade-more" alt="" @click="showMore">
				</div>
			</div>
			<div class="trade-info">

				<div class="flex-start-between trade-container" v-if="tabIndex != 2">
					<!--左侧-->
					<div class="trade-left" :class="tabIndex == 0 ? 'spot' : ''">
						<div class="action-btn flex" v-if="tabIndex == 0">
							<div class="btn flex-center btn1" :class="tradeType == 'buy' ? 'green' : ''" @click="changeType('buy')">{{i18n.t('trade.buy1')}}</div>
							<div class="btn flex-center btn2"  :class="tradeType == 'sell' ? 'red' : ''" @click="changeType('sell')">{{i18n.t('trade.sell1')}}</div>
						</div>

						<div class="flex" v-if="tabIndex == 1">
							<div class="flex-center scale-btn" @click="changeMultSetting">
								<span>{{multForm.fullType == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{multForm.multiple}}X</span>
								<img :src="downUrl3" alt="">
							</div>
						</div>

						<div class="flex-center-between user-amount">
							<div class="label">{{i18n.t('trade.label3')}}</div>
							<div class="flex-center amount">
								<span class="available-balance-text">{{availableBalanceText}} {{availableBalanceUnit}}</span>
								<img
									class="available-balance-eye"
									:src="showAvailableBalance ? eyeUrl2 : eyeUrl"
									:alt="availableBalanceToggleLabel"
									:title="availableBalanceToggleLabel"
									role="button"
									:aria-label="availableBalanceToggleLabel"
									tabindex="0"
									@click.stop="toggleAvailableBalance"
									@keydown.enter.stop.prevent="toggleAvailableBalance"
									@keydown.space.stop.prevent="toggleAvailableBalance"
								>
								<img class="available-balance-transfer" :src="transferUrl2" alt="" @click="toTransfer">
							</div>
						</div>

						<div class="trade-type flex-center-between" @click="showPicker">
							<div>{{actionTypeName}}</div>
							<img :src="downUrl3" alt="">

						</div>
						<div class="trade-money flex-center-between" :class="inputActive ? 'active' : ''" v-if="actionType == 1">
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive = true" @blur="inputActive = false"  @change="changeMoney" @input="changeMoney" v-model="tradeMoney" :placeholder="i18n.t('trade.label4')">
							</div>
							<div class="flex-center icon">
								USDT
							</div>
						</div>
						<div class="trade-money flex-center-between " :class="inputActive ? 'active' : ''" v-if="actionType == 2">
							<div>
								<input readonly  :placeholder="$t('trade.label21')">
							</div>
							<div class="flex-center icon">
								USDT
							</div>

						</div>

						<div class="trade-money  flex-center-between " :class="inputActive2 ? 'active' : ''" v-if="actionType == 3 && tabIndex == 0">
							<div class="left width-full flex-center-between">
								<input type="number" inputmode="decimal"  @focus="inputActive2 = true" @blur="inputActive2 = false" v-model="form.stopPrice" :placeholder="i18n.t('trade.label5')">
								<div>USDT</div>
							</div>
						</div>
						<div class="trade-money  flex-center-between " :class="inputActive3 ? 'active' : ''" v-if="actionType == 3 || actionType == 4">
							<div class="left flex-center-start">
								<input type="number" inputmode="decimal" @focus="inputActive3 = true" @blur="inputActive3 = false" v-model="tradeMoney" @change="changeMoney" @input="changeMoney" :placeholder="i18n.t('trade.label4')" >
							</div>
							<div class="right flex-center limit-dom" @click="showPicker3" >{{form.limitTypeName}}</div>
						</div>

						<div class=" space-height">

						</div>



						<div class="trade-money flex-center-between fixed-input" :class="[actionType != 4 && tabIndex == 0 ? 'clear' : '', inputActive4 ? 'active' : '']" v-if="actionType == 1 || actionType == 3 || actionType == 4">
							<div>
								<input type="number" inputmode="decimal" pattern="[0-9]*" @focus="inputActive4 = true" @blur="inputActive4 = false; showPreview = false" v-model="form.number" @change="changeCount" @input="changeCount" :placeholder="i18n.t('trade.label7')">
							</div>
							<div>{{bitInfo.ShortName}}</div>
							<div class="total-perview" v-show="showPreview">
								≈ {{previewTotal}} USDT
							</div>
						</div>

						<div class="trade-money flex-center-between fixed-input" v-if="actionType == 2" :class="inputActive5 ? 'active' : ''">
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive5 = true" @blur="inputActive5 = false; showPreview = false" v-model="form.number" :placeholder="i18n.t('trade.label7')" @change="changeCount" @input="changeCount">
							</div>
							<div>{{bitInfo.ShortName}}</div>
							<div class="total-perview" v-show="showPreview">
								≈ {{previewTotal}} USDT
							</div>
						</div>

						<div class="slide-box ">
							<div class="slide-inner flex-center" >
								<Slider v-model="tradeMoneyPercent" step="5" bar-height="4px" active-color="none" inactive-color="none" @change="changeSlide" @drag-start="dragStart" @drag-end="dragEnd">
									 <template #button>
										<div class="custom-button"></div>
									</template>
								</Slider>
								<div class="slide-bg">
									<div class="slide-value flex-center" v-show="showPercent" :style="`left: ${tradeMoneyPercent}%;`">{{tradeMoneyPercent}}%</div>
									<div class="active-line" :style="`width: ${tradeMoneyPercent}%;`"></div>
									<div class="point" v-for="i in 6" :key="i" :class="[(i - 1) * 20 <= tradeMoneyPercent ? 'active' : '', `point${i}`]">
										<div class="value">{{(i - 1) * 20}}%</div>
									</div>
								</div>
							</div>
						</div>

						<div class="statistics" v-if="actionType == 3 && tabIndex == 1">
							<div class="flex-center-between line">
								<div class="label">{{i18n.t('trade.label9')}}</div>
								<div class="flex-cetner">
									<span class="green">{{winForm.winMoney}}</span>
									<span>USDT</span>
								</div>
							</div>
							<div class="flex-center-between line">
								<div class="label">{{i18n.t('trade.label10')}}</div>
								<div class="flex-cetner">
									<span class="red">{{winForm.loseMoney}}</span>
									<span>USDT</span>
								</div>
							</div>
						</div>


						<div class="add-btn flex-center" v-if="actionType == 3 && tabIndex == 1" @click="changeWinSetting">
							<img :src="addUrl2" alt="">
							<span>{{i18n.t('trade.label11')}}</span>
						</div>

						<!-- <div class="trade-money flex-center-between clear" v-if="actionType == 1 || actionType == 3" :class="inputActive6 ? 'active' : ''">
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive6 = true" @blur="inputActive6 = false" :placeholder="i18n.t('trade.label12')" @change="changeTotal" @input="changeTotal" v-model="form.totalMoney">
							</div>
							<div>USDT</div>
						</div> -->

						<div class="sale-info" v-if="tabIndex == 0 && isLogin">
							<div v-if="tradeType == 'buy'">{{$t('trade.label63')}}：{{buyCount}}{{bitInfo.ShortName}}</div>
							<div v-else>{{$t('trade.label64')}}：{{saleCount}}USDT</div>
						</div>

						<Button v-if="tabIndex == 0 && isLogin" class="bottom-action-btn bottom-submit-btn" @click="submit" :class="[tradeType == 'buy' ? 'green' : 'red', `type${actionType}`]">{{tradeType == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}} {{bitInfo.ShortName}}</Button>
						<Button v-if="tabIndex == 0 && !isLogin" class="bottom-action-btn bottom-submit-btn" @click="toPath('login')" :class="[tradeType == 'buy' ? 'green' : 'red', `type${actionType}`]">{{i18n.t('login.title')}}</Button>
						<div class="flex-center-between bottom-submit-btn" v-if="tabIndex == 1 && isLogin">
							<Button class="bottom-action-btn green" @click="submitContract('long')">{{i18n.t('trade.buy2')}}</Button>
							<Button class="bottom-action-btn red" @click="submitContract('short')">{{i18n.t('trade.sell2')}}</Button>
						</div>
						<div class="flex-center-between bottom-submit-btn" v-if="tabIndex == 1 && !isLogin">
							<Button class="bottom-action-btn green" @click="toPath('login')">{{i18n.t('login.title')}}</Button>
						</div>
						<!-- <div class="other-setting" v-if="tabIndex == 1">
							<div class="flex-center-between">
								<div>
									<Checkbox v-model="form.setting1"  shape="square" checked-color="#F7A600">被动订单</Checkbox>
								</div>
								<div class="flex-center">
									<span>GTC</span>
									<img :src="downUrl3" alt="">
								</div>
							</div>
							<div class="mt-5">
								<Checkbox v-model="form.setting2"  shape="square" checked-color="#F7A600">只减仓</Checkbox>
							</div>
						</div> -->
					</div>
					<!--右侧-->
					<div class="trade-right flex-column-start">
						<div class="trade-time" v-if="tabIndex == 1">
							<div class="label">{{i18n.t('trade.label13')}} / {{i18n.t('trade.label14')}}</div>
							<div class="time">0.0100% / 02:02:58</div>
						</div>

						<div class="th-line flex-center-between">
							<div class="th">{{i18n.t('trade.label15')}}</div>
							<div class="th">{{i18n.t('trade.label16')}}</div>
						</div>
						<div class="th-line flex-center-between mb-6">
							<div class="th">(USDT)</div>
							<div class="th">({{bitInfo.ShortName}})</div>
						</div>

						<div class="flex-center-between list" v-for="(item, i) in upDealList" :key="i" @click="checkPrice(item)">
							<div class="red">{{item.value ? resetValue(item.value) : '--'}}</div>
							<div>{{item.dealCount || '--'}}</div>
							<div class="bg red" :style="getBgWidth(item.count, i, 1)"></div>
						</div>

						<div class="value flex-column-start-center" :class="`type${actionType}`">
							<div class="count" :class="bitInfo.percent > 0 ? 'green' : 'red'">{{bitInfo.count}}</div>
							<div class="small">≈{{resetBitMoney2(bitInfo.count)}} {{currencyVal}}</div>
						</div>

						<div class="flex-center-between list" v-for="(item, index) in downDealList" :key="'down' + index" @click="checkPrice(item)">
							<div class="green">{{item.value ? resetValue(item.value) : '--'}}</div>
							<div>{{item.dealCount || '--'}}</div>
							<div class="bg green" :style="getBgWidth(item.count, index, 2)"></div>
						</div>

						<div class="deep-line flex-center-between">
							<div class="picker flex-center-between" @click="showDeepPicker">
								<div>{{deepName}}</div>
								<img :src="downUrl3" alt="">
							</div>
							<div class="icon flex-center">
								<img :src="deepType == 1 ? defaultUrl : (deepType == 2 ? buyUrl : saleUrl)" alt="" @click="showTypePicker">
							</div>
						</div>

					</div>
				</div>

				<!--走势图-->
				<div class="chart-box" v-show="tabIndex == 2" >
					<div class="price flex-center-between">
						<span class="big">{{bitInfo.count}}</span>
						<span> ≈ {{resetBitMoney2(bitInfo.count)}} {{currencyVal}}</span>
					</div>

					<chart-page ref="chartPage" :id="bitInfo.ID" :showChart="tabIndex == 2"></chart-page>

					<div class="flex-center-start user-info">
						<div class="label">{{i18n.t('trade.label17')}}</div>
						<div class="money available-balance-text">{{availableBalanceText}} {{availableBalanceUnit}}</div>
						<img
							class="available-balance-eye"
							:src="showAvailableBalance ? eyeUrl2 : eyeUrl"
							:alt="availableBalanceToggleLabel"
							:title="availableBalanceToggleLabel"
							role="button"
							:aria-label="availableBalanceToggleLabel"
							tabindex="0"
							@click.stop="toggleAvailableBalance"
							@keydown.enter.stop.prevent="toggleAvailableBalance"
							@keydown.space.stop.prevent="toggleAvailableBalance"
						>
						<img class="available-balance-transfer" :src="transferUrl2" alt="" @click="toTransfer">
					</div>

					<div class="flex-center-between btn-line">
						<Button class="green" @click="showUpDownModal(1)">{{i18n.t('trade.buy3')}}</Button>
						<Button class="red" @click="showUpDownModal(2)">{{i18n.t('trade.sell3')}}</Button>
					</div>
				</div>

			</div>

			<div class="space-line"></div>

			<!--订单-->
			<div class="order-info">
				<div class="flex-center-between title">
					<div class="tab-list flex">
						<div class="tab" :class="orderTabIndex == 1 ? 'active' : ''" @click="changeOrderTab(1)">{{tabIndex == 2 ? i18n.t('trade.label50') : (tabIndex == 1 ? i18n.t('trade.label47') : i18n.t('trade.label46')) }}</div>
						<!-- <div class="tab" :class="orderTabIndex == 3 ? 'active' : ''" @click="changeOrderTab(3)" v-show="tabIndex == 1">{{i18n.t('trade.label47')}}</div> -->
						<div class="tab" v-show="tabIndex == 0" :class="orderTabIndex == 2 ? 'active' : ''" @click="changeOrderTab(2)" >{{i18n.t('trade.label51')}}</div>
					</div>
					<div class="flex-center all" @click="showOrder">
						<img :src="orderUrl" alt="">
					</div>
				</div>

				<!-- <div class="show-all flex-center-start">
					<Checkbox v-model="showAll"  shape="square" checked-color="#F7A600">{{i18n.t('trade.label20')}}</Checkbox>
				</div> -->

				<div class="order-list pd-bottom">
					<div class="trade-list" v-if="tabIndex == 0 && orderTabIndex == 1">
						<div class="list" v-for="(item, i) in orderList" :key="i">
							<div class="flex-center-between">
								<div class="list-title flex-center">
									<span>{{item.Currency.ShortName}}/USDT</span>
								</div>

								<div class="cancel-btn flex-center" v-if="item.Status == 0"  @click="cancelOrder(item)">
									<img :src="clearUrl" alt="">
									<span >{{ i18n.t('trade.status3')}}</span>
								</div>
							</div>
							<div class="flex-center-between status">
								<div class="flex-center">
									<span class="tab" :class="item.Trade == 'buy' ? 'green' : 'red'">{{item.Trade == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}</span>
									<div>{{item.Trust == 'limit' ? i18n.t('trade.label53') : i18n.t('trade.label52')}}</div>
								</div>
								<div class="time">{{formatOrderTime(item.CreatedAt)}}</div>
							</div>
							<!-- <div class="status" :class="item.Status == 2 ? 'red' : 'green'">{{item.Status == 0 ? i18n.t('trade.status1') : (item.Status == 1 ?  i18n.t('trade.status2') :  i18n.t('trade.status3'))}}</div> -->

							<div class="flex-center list-horizontal-line mt-5">
								<div class="flex-1 label">{{i18n.t('trade.th1')}}</div>
								<div class="flex-1 label text-center">{{i18n.t('trade.th2')}}</div>
								<div class="flex-1 label text-right">{{i18n.t('trade.th3')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-1 ">{{parseFloat(item.TrustClose).toFixed(4)}} </div>
								<div class="flex-1 text-center">{{parseFloat(item.Close).toFixed(4)}} </div>
								<div class="flex-1  text-right">{{parseFloat(item.CloseCount).toFixed(4)}} </div>
							</div>

							<div class="flex-center list-horizontal-line mt-12">
								<div class="flex-1 label">{{i18n.t('trade.th4')}}</div>
								<div class="flex-1 label text-center">{{i18n.t('trade.th5')}}</div>
								<div class="flex-1 label text-right">{{$t('trade.label54')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-1 ">{{parseFloat(item.TrustNum).toFixed(4)}}</div>
								<div class="flex-1 text-center">{{parseFloat(item.CloseNum).toFixed(4)}}</div>
								<div class="flex-1 text-right">{{$t(`trade.status${item.Status + 1}`)}}</div>
							</div>

						</div>
					</div>
					<!--现货资产-->
					<div class="bit-list rankList clear" v-if="tabIndex == 0 && orderTabIndex == 2">
						<div class="list clear rank " v-for="(item, i) in walletBitList" :key="i">
							<div class="flex-center-start">
								<div class="icon">
									<img :src="`/upload/${item.Currency.Logo}`" alt="">
								</div>
								<div class="name">
									{{item.Currency.ShortName}}
								</div>
							</div>

							<div class="flex-center-between assest-box">
								<div>
									<div class="label">{{$t('trade.label65')}}</div>
									<div class="count">{{(parseFloat(item.SpotUse) + parseFloat(item.SpotFree)).toFixed(4)}}</div>
									<div class="gray">${{resetBitMoney(parseFloat(item.SpotUse) + parseFloat(item.SpotFree))}}</div>
								</div>
								<div>
									<div class="label">{{$t('trade.label66')}}</div>
									<div class="count">{{parseFloat(item.SpotFree).toFixed(4)}}</div>
									<div class="gray">${{resetBitMoney(parseFloat(item.SpotFree))}}</div>
								</div>
								<div class="text-right">
									<div class="label">{{$t('trade.label67')}}</div>
									<div class="count">{{parseFloat(item.SpotUse).toFixed(4)}}</div>
									<div class="gray">${{resetBitMoney(parseFloat(item.SpotUse))}}</div>
								</div>
							</div>


									<!-- <div class="icon">

							</div>
							<div class="flex-1">
								<div class="flex-center-between name">
									<div>
										{{item.Currency.ShortName}}
									</div>
									<div >{{parseFloat(item.SpotUse).toFixed(4)}}</div>
								</div>
								<div class="flex-center-between desc">
									<div>{{item.Currency.Remark}}</div>

									<div  class="percent" >
										{{resetSpotMoney(item.SpotUse, item.Currency.ID)}} USDT
									</div>

								</div>
							</div> -->

						</div>
					</div>
					<!--合约-->
					<div class="trade-list" v-if="tabIndex == 1">
						<div class="list" v-for="(item, i) in contractOrderList" :key="i">
							<div class="flex-center-between">
								<div class="list-title flex-center">
										<div class="tab" :class="[item.Direction == 'long' ? 'green' : 'red', i18n.t('trade.label21').length > 12 ? 'small' : '']">{{item.Direction == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}</div>
										<span>{{item.Currency.ShortName}}/USDT </span>
								</div>
								<div class="cancel-btn flex-center" @click="cancelContract(item)" v-if="item.Status == 0">
									<img :src="clearUrl" alt="">
									<span  >{{ i18n.t('trade.status3')}}</span>
								</div>
							</div>
							<div class="flex-center-between status">
								<div>{{item.Full == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{item.Multiple}}X</div>
								<div class="time">{{formatOrderTime(item.CreatedAt)}}</div>
							</div>

							<div class="flex-center list-horizontal-line mt-12">
								<div class="flex-2 label">{{i18n.t('trade.th11')}}</div>
								<div class="flex-2 label text-center">{{i18n.t('trade.th7')}}(USDT)</div>
								<div class="flex-2 label text-right">{{i18n.t('trade.th25')}}(USDT)</div>
							</div>


							<div class="flex-center list-horizontal-line">
								<div class="flex-2">{{parseFloat(item.OpenNum).toFixed(4)}}</div>
								<div class="flex-2 text-center">{{parseFloat(item.Margin).toFixed(4)}}</div>
								<div class="flex-2 text-right">{{parseFloat(item.Profit).toFixed(4)}}</div>
							</div>

							<div class="flex-center list-horizontal-line mt-12">
								<div class="flex-2 label ">{{i18n.t('trade.th10')}}</div>
								<div class="flex-2 label text-center">{{i18n.t('trade.th9')}}</div>
								<div class="flex-2 label text-right">{{i18n.t('trade.th12')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-2 ">{{parseFloat(item.OpenClose).toFixed(4)}}</div>
								<div class="flex-2 text-center">{{parseFloat(item.TrustClose).toFixed(4)}}</div>
								<div class="flex-2 text-right">{{parseFloat(item.Close).toFixed(4)}}</div>
							</div>



							<div class="flex-center-between mt-12 btn-line" v-if="item.Status != 0">
								<div class="list-btn " @click="setWinOrLose(item)">
									{{$t('trade.label11')}}
								</div>
								<div class="list-btn" @click="toClearOrder(item)">{{i18n.t('trade.status5')}}</div>
							</div>

						</div>
					</div>
					<!--期权-->
					<div class="trade-list" v-if="tabIndex == 2">
						<div class="list" v-for="(item, i) in optionOrderArr" :key="i" :class="{ 'retained-order': isRetainedOrder(item.ID) }">
							<div class="flex-center-between">
								<div class="list-title flex-center">
									<span>{{item.Currency.ShortName}}/USDT</span>
									<span v-if="isRetainedOrder(item.ID)" class="retained-label">{{ $t('trade.status7') }}</span>
								</div>

								<div class="" >
										<div class="time">{{formatOrderTime(item.CreatedAt)}}</div>
								</div>
							</div>

							<div class="flex-center-start tag">
								<span class="tab" :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}</span>
								<div>{{item.Amount || 0}} USDT</div>
							</div>

							<div class="flex-center list-horizontal-line mt-5">
								<div class="flex-1 label">{{i18n.t('trade.th19')}}</div>
								<div class="flex-1 label text-center">{{i18n.t('trade.th21')}}</div>
								<div class="flex-1 label text-right">{{i18n.t('trade.th25')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-1 ">{{parseFloat(item.MarkPrice).toFixed(4)}}</div>
								<div class="flex-1 text-center">{{parseFloat(item.SettlementPrice).toFixed(4)}}</div>
								<div class="flex-1  text-right" :class="item.Profit > 0 ? 'green' : (item.Profit < 0 ? 'red' : '')">{{item.Profit > 0 ? '+' : ''}}{{parseFloat(item.Profit).toFixed(4)}} </div>
							</div>

              <div class="flex-center list-horizontal-line mt-5">
								<div class="flex-1 label">{{i18n.t('trade.label4')}}</div>
								<div class="flex-1 label text-center">{{i18n.t('trade.label14')}}</div>
								<div class="flex-1 label text-right">{{i18n.t('trade.label54')}}</div>
							</div>

							<div class="flex-center list-horizontal-line">
								<div class="flex-1">{{item.Amount}} USDT</div>
								<div class="flex-1 text-center">
                  <template v-if="item.Status == 0">
                    <span v-if="getCountdown(item) > 0" class="countdown">{{ getCountdown(item) }}s</span>
                    <span v-else class="settling">{{ $t('trade.statusSettling') }}</span>
                  </template>
                  <span v-else>{{item.Settlement}}s</span>
                </div>
								<div class="flex-1 text-right">{{$t(`trade.status${item.Status + 1}`)}}</div>
							</div>
							<!-- <div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th16')}}</div>
								<div>{{item.Currency.ShortName}}/USDT</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th17')}}</div>
								<div class="label" :class="item.Status == 2 ? 'red' : 'green'">{{item.Status == 0 ? i18n.t('trade.status6') : (item.Status == 1 ? i18n.t('trade.status7') : i18n.t('trade.status8'))}}</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th18')}}</div>
								<div class="label">{{item.CreatedAt}}</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th19')}}</div>
								<div class="label">{{parseFloat(item.MarkPrice).toFixed(4)}}</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th20')}}</div>
								<div class="label">{{item.SettlementTime}}</div>
							</div>
							<div class="list-line flex-center-between" v-if="item.Status == 1">
								<div class="label">{{i18n.t('trade.th21')}}</div>
								<div class="label">{{item.SettlementPrice}}</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th22')}}</div>
								<div class="label" :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? i18n.t('trade.buy4') : i18n.t('trade.sell4')}}</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th23')}}</div>
								<div class="label">{{item.Settlement}}S</div>
							</div>
							<div class="list-line flex-center-between">
								<div class="label">{{i18n.t('trade.th24')}}</div>
								<div class="label">{{parseFloat(item.Amount).toFixed(4)}} USDT</div>
							</div>
							<div class="list-line flex-center-between" v-if="item.Status == 1">
								<div class="label">{{i18n.t('trade.th25')}}</div>
								<div class="label" :class="item.Profit > 0 ? 'green' : 'red'">{{parseFloat(item.Profit).toFixed(4)}}</div>
							</div> -->
							<!-- <div class="list-line flex-center-between">
								<div class="label">当前价格</div>
								<div class="label">{{}}</div>
							</div> -->
						</div>
					</div>
					<div class="empty-main flex-column-center" v-if="(orderList.length == 0 && orderTabIndex == 1  && tabIndex == 0) || (walletBitList.length == 0 && orderTabIndex == 2 && tabIndex == 0) || (contractOrderList.length == 0 && tabIndex == 1) || (optionOrderArr.length == 0 && tabIndex == 2)">
						<!-- <div class="msg">{{$t(`trade.label58_${tabIndex}`)}}</div> -->
						<div class="desc" v-if="!isModal">{{$t(`trade.label59_${tabIndex}`)}}</div>
						<div class="desc" v-if="isModal">{{$t(`trade.label61_${tabIndex}`)}}</div>
						<div class="flex-center img-box">
							<div class="flex-column-center link" @click="toPath('recharge')">
								<img :src="rechargeUrl" alt="">
								<span>{{$t('assest.label2')}}</span>
							</div>
							<div class="flex-column-center link" @click="toTransfer">
								<img :src="transferUrl" alt="">
								<span>{{$t('trade.label60')}}</span>
							</div>
							<!-- 模拟交易入口 - 暂时隐藏，未来可能重新启用 -->
							<!-- <div class="flex-column-center link" @click="toPath('imitate')" v-if="!isModal">
								<img :src="tradeUrl" alt="">
								<span>{{$t('trade.title0')}}</span>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--市价单、限价单选择-->
		<Popup v-model:show="showPickerModal" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal height-2">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.title4')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="trade-picker-list " >
					<div class="list" v-for="(item, i) in actionTypeList" :key="i" :class="item.value == actionType ? 'active' : ''" @click.stop="changeActionType(item)">
						{{item.text}}
					</div>
				</div>
			</div>
		</Popup>

		<!--止盈止损选择-->
		<Popup v-model:show="showPickerModal2" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.title5')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="trade-picker-list " >
					<div class="list" v-for="(item, i) in triggerTypeList" :key="i" :class="item.value == form.triggerType ? 'active' : ''" @click.stop="changeTriggerType(item)">
						{{item.text}}
					</div>
				</div>
			</div>
		</Popup>
		<!--市价、限价选择-->
		<Popup v-model:show="showPickerModal3" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.title6')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="trade-picker-list " >
					<div class="list" v-for="(item, i) in limitTypeList" :key="i" :class="item.value == form.limitType ? 'active' : ''" @click.stop="changeLimitType(item)">
						{{item.text}}
					</div>
				</div>
			</div>
		</Popup>

		<!--更多-->
		<!-- <div class="shade-box" v-show="showMoreModal" @click="cancel">
			<div class="more-list" :style="`top: ${moreTop}px;`" >
				<div class="list flex-center-start" @click.stop="toInfo('trade')">
					<img :src="lineUrl" alt="">
					<span>{{i18n.t('trade.desc1')}}</span>
				</div>
				<div class="list flex-center-start"  @click.stop="toInfo('rate')">
					<img :src="helpUrl" alt="">
					<span>{{i18n.t('trade.desc2')}}</span>
				</div>
			</div>
		</div> -->
		<Popup v-model:show="showMoreModal" position="bottom" class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t(`trade.desc29`)}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="modal-menu-list flex-wrap">
					<div class="menu flex-column-center" v-for="(item, i) in modalMenuList" :key="i" @click="toPath(item.path, item.query)">
						<img :src="item.url" alt="">
						<span>{{item.name}}</span>
					</div>
				</div>
			</div>
		</Popup>

		<!--委托深度、方式-->
		<Popup v-model:show="showPopup" position="bottom" class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t(`trade.desc${pickerType == 'deep' ? 3 : 4}`)}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="trade-picker-list " v-if="pickerType == 'deep'">
					<div class="list" v-for="(item, i) in deepList" :key="i" :class="item == deepName ? 'active' : ''" @click.stop="changeDeep(item)">
						{{item}}
					</div>
				</div>
				<div class="trade-picker-list " v-if="pickerType == 'type'">
					<div class="list flex-center-start" v-for="(item, i) in typeList" :key="i" :class="item.type == deepType ? 'active' : ''" @click.stop="changeDeepType(item)">
						<img :src="item.type == 1 ? defaultUrl : (item.type == 2 ? buyUrl : saleUrl)" alt="">
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
		</Popup>

		<!--费率-->
		<Popup v-model:show="showRate" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.desc5')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>

				<div class="info-line">{{i18n.t('trade.desc6')}}</div>

				<div class="info-line top">{{i18n.t('trade.desc7')}}</div>
				<div class="info-line">{{i18n.t('trade.desc8')}}</div>
				<div class="info-line">{{i18n.t('trade.desc9')}}</div>

				<div class="info-line top">{{i18n.t('trade.desc10')}}</div>
				<div class="info-line top">{{i18n.t('trade.desc11')}}</div>
				<div class="info-line top">{{i18n.t('trade.desc12')}}</div>
				<div class="info-line">{{i18n.t('trade.desc13')}}</div>
				<div class="info-line">{{i18n.t('trade.desc14')}}</div>
				<div class="info-line">{{i18n.t('trade.desc15')}}</div>
				<div class="info-line">{{i18n.t('trade.desc16')}}</div>
				<div class="info-line">{{i18n.t('trade.desc17')}}</div>
				<div class="info-line">{{i18n.t('trade.desc18')}}</div>

				<div class="info-line top">{{i18n.t('trade.desc19')}}</div>
				<div class="info-line">{{i18n.t('trade.desc20')}}</div>
				<div class="info-line">{{i18n.t('trade.desc21')}}</div>
				<div class="info-line">{{i18n.t('trade.desc22')}}</div>
			</div>
		</Popup>

		<!--选择币种-->
		<Popup v-model:show="showBit" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal big">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.desc23')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="search-line">
					<Search v-model="keyword" :placeholder="i18n.t('trade.btn4')" @clear="clearSearch" @search="searchMarket" @input="searchMarket"></Search>
				</div>
				<div class="rankList clear">
					<div class="modal-th flex-center">
						<div class="th flex-3">{{$t('index.label9')}}</div>
						<div class="th flex-2 text-right">{{$t('index.label10')}}(USDT)</div>
						<div class="th flex-2 text-right">{{$t('index.label11')}}</div>
					</div>
					<bit-page :dataList="marketList" @detail="chooseBit" :subscribe="false"></bit-page>
				</div>
			</div>
		</Popup>

		<!--全仓倍数设置弹框-->
		<Popup v-model:show="showMultModal" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.desc24')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="win-setting">
					<div class="action-btn flex">
						<div class="btn flex-center" :class="multForm.fullType == 'full' ? 'green' : ''" @click="changeFullType('full')">{{i18n.t('trade.label1')}}</div>
						<div class="btn flex-center"  :class="multForm.fullType == 'warehousing' ? 'red' : ''" @click="changeFullType('warehousing')">{{i18n.t('trade.label2')}}</div>
					</div>
					<div class="flex-center-between setting-title">
						<div>{{i18n.t('trade.label23')}}</div>
					</div>

					<div class="slide-box black">
						<div class="slide-inner flex-center" >
							<Slider v-model="multForm.multiple" :min="0" :max="125" step="5" bar-height="4px" active-color="none" inactive-color="none" @input="changeMultipleSlide" @drag-start="dragMultipleStart" @drag-end="dragMultipleEnd">
									<template #button>
									<div class="custom-button"></div>
								</template>
							</Slider>
							<div class="slide-bg">
								<div class="slide-value flex-center" v-show="showMultiplePercent" :style="`left: ${multiplePercent}%;`">{{multForm.multiple > 0 ? multForm.multiple : 1}}X</div>
								<div class="active-line" :style="`width: ${multiplePercent}%;`"></div>
								<div class="point" v-for="i in 6" :key="i" :class="[(i - 1) * 25 <= multForm.multiple ? 'active' : '', `point${i}`]">
									<div class="value">{{i == 1 ? 1 : (i - 1) * 25}}X</div>
								</div>
							</div>
						</div>
					</div>

					<div class="bottom-btn">
						<Button @click="ensureMult">{{i18n.t('trade.btn2')}}</Button>
					</div>
				</div>
			</div>
		</Popup>

		<!--止盈止损设置弹框-->
		<Popup v-model:show="showWinSetting" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('trade.desc25')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="win-setting">
					<!-- <div class="action-btn flex">
						<div class="btn flex-center" :class="winForm.tradeType == 'buy' ? 'green' : ''" @click="changeWinType('buy')">做多</div>
						<div class="btn flex-center"  :class="winForm.tradeType == 'sell' ? 'red' : ''" @click="changeWinType('sell')">做空</div>
					</div> -->

					<div class="win-info" v-if="showWinInfo">
						<div class="info-line flex-center-between">
							<div class="label">{{i18n.t('trade.th10')}}</div>
							<div>{{parseFloat(winData.OpenClose).toFixed(4)}}</div>
						</div>
						<div class="info-line flex-center-between">
							<div class="label">{{i18n.t('trade.label21')}}</div>
							<div>{{bitInfo.count}}</div>
						</div>
						<div class="info-line flex-center-between">
							<div class="label">{{i18n.t('trade.th12')}}</div>
							<div>{{parseFloat(winData.Close).toFixed(4)}}</div>
						</div>
					</div>

					<div class="flex-center-between setting-title">
						<div>{{i18n.t('trade.label24')}}</div>

					</div>

					<div class="trade-money flex-center-between" :class="inputActive7 ? 'active' : ''">
						<div class="left full-width flex-center-between">
							<div class="flex-center icon">
								<img :src="minusUrl" alt="" @click="minusWinMoney(1)">
							</div>
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive7 = true" @blur="checkWinMoney(1)" v-model="winForm.winMoney" :placeholder="i18n.t('trade.label26')">
							</div>
							<div class="flex-center icon">
								<img :src="addUrl2" alt="" @click="addWinMoney(1)">
							</div>
						</div>
					</div>

					<!-- <div class="flex percent-line">
						<div class="percent flex-center" v-for="(item, i) in percentList" :key="i" :class="winForm.winPercent == item ? 'active' : ''" @click="changePercent(item, 1)">{{item}}%</div>
					</div> -->
<!--
					<div class="slide-box black">
						<div class="slide-inner flex-center" >
							<Slider v-model="winForm.winPercent" :min="0" :max="150" step="5" bar-height="4px" active-color="none" inactive-color="none" @input="changeWinPercent" @drag-start="dragWinStart" @drag-end="dragWinEnd">
									<template #button>
									<div class="custom-button"></div>
								</template>
							</Slider>
							<div class="slide-bg">
								<div class="slide-value flex-center" v-show="showWinPercent" :style="`left: ${winPercent}%;`">{{winForm.winPercent > 0 ? winForm.winPercent : 1}}%</div>
								<div class="active-line" :style="`width: ${winPercent}%;`"></div>
								<div class="point" v-for="i in 6" :key="i" :class="[(i - 1) * 30 <= winForm.winPercent ? 'active' : '', `point${i}`]">
									<div class="value">{{i == 1 ? 1 : (i - 1) * 30}}%</div>
								</div>
							</div>
						</div>
					</div> -->

					<!---止损-->
					<div class="flex-center-between setting-title">
						<div>{{i18n.t('trade.label27')}}</div>

					</div>

					<div class="trade-money flex-center-between" :class="inputActive8 ? 'active' : ''">
						<div class="left flex-center-between">
							<div class="flex-center icon">
								<img :src="minusUrl" alt="" @click="minusWinMoney(2)">
							</div>
							<div>
								<input type="number" inputmode="decimal" @focus="inputActive8 = true" @blur="checkWinMoney(2)" v-model="winForm.loseMoney" :placeholder="i18n.t('trade.label28')">
							</div>
							<div class="flex-center icon">
								<img :src="addUrl2" alt="" @click="addWinMoney(2)">
							</div>
						</div>

					</div>
<!--
					<div class="slide-box black">
						<div class="slide-inner flex-center" >
							<Slider v-model="winForm.losePercent" :min="0" :max="90" step="3" bar-height="4px" active-color="none" inactive-color="none" @input="changeLosePercent" @drag-start="dragLoseStart" @drag-end="dragLoseEnd">
									<template #button>
									<div class="custom-button"></div>
								</template>
							</Slider>
							<div class="slide-bg">
								<div class="slide-value flex-center" v-show="showLosePercent" :style="`left: ${losePercent}%;`">{{winForm.losePercent > 0 ? winForm.losePercent : 1}}%</div>
								<div class="active-line" :style="`width: ${losePercent}%;`"></div>
								<div class="point" v-for="i in 6" :key="i" :class="[(i - 1) * 18 <= winForm.losePercent ? 'active' : '', `point${i}`]">
									<div class="value">{{i == 1 ? 1 : (i - 1) * 18}}%</div>
								</div>
							</div>
						</div>
					</div> -->

					<!-- <div class="flex percent-line">
						<div class="percent flex-center" v-for="(item, i) in losePercentList" :key="i" :class="winForm.losePercent == item ? 'active' : ''" @click="changePercent(item, 2)">{{item}}%</div>
					</div> -->

					<!-- <div class="desc-line">
						<div class="desc-title flex-center-between" @click="showDetail">
							<span>{{i18n.t('trade.desc26')}}</span>
							<img :src="downUrl2" alt="" :class="showWinDesc ? '' : 'hide'">
						</div>
						<div class="desc-info" :class="showWinDesc ? '' : 'hide'">
							{{i18n.t('trade.desc27')}}
						</div>
					</div> -->

					<div class="bottom-btn">
						<Button @click="ensureWin">{{i18n.t('trade.btn2')}}</Button>
					</div>
				</div>
			</div>
		</Popup>
		<!--看涨看跌-->
		<Popup v-model:show="showUpDownPopup" position="bottom" lock-scroll class="rate-popup">
			<div class="up-down-box">
				<div class="flex-center-between">
					<div class="title">
						<span >{{i18n.t('trade.label29')}} {{bitInfo.ShortName}} {{i18n.t('trade.label30')}}</span>
						<span class="label" :class="upDownType == 1 ? 'green' : 'red'">{{upDownType == 1 ? i18n.t('trade.label39') : i18n.t('trade.label40')}}</span>
					</div>
					<!-- <div @click="cancel" class="cancel">{{i18n.t('trade.btn1')}}</div> -->
					<img :src="closeUrl" alt="" @click="cancel" class="cancel">
				</div>

				<div class="time-box flex-wrap">
					<template v-if="optionSettingLoading">
						<div class="time option-skeleton" v-for="i in 6" :key="`option-loading-${i}`"></div>
					</template>
					<template v-else>
						<div class="time flex-center"  v-for="(item, i) in timeList" :key="i" @click="changeUpDownPercent(item)" :class="[upDownForm.time == item.Time ? 'active' : '', upDownType == 1 ? 'green' : 'red']">
							{{item.Time}}S {{parseFloat(item.ProfitRatio)}}%
						</div>
					</template>
				</div>

				<div class="flex-center-between info-line">
					<div class="label">{{i18n.t('trade.label31')}}</div>
					<div v-if="optionSettingLoading" class="option-skeleton-text"></div>
					<div v-else>{{i18n.t('trade.label32')}}: {{futuresObj ? futuresObj.TrusteeFeeRatio : 0}}%</div>
				</div>

				<div class="input-box">
<!--					<input type="number" inputmode="decimal" v-model="upDownForm.money" :placeholder="`${i18n.t('trade.label33')} ${futuresObj ? futuresObj.MinInvestment : ''} USDT`">-->
					<input type="number" inputmode="decimal" v-model="upDownForm.money" :disabled="optionSettingLoading || !hasOptionSetting" :placeholder="futuresObj ? `${i18n.t('trade.label73')} ${futuresObj.MinInvestment} USDT` : i18n.t('trade.label74')">
				</div>

				<div class="profit">
					<div class="flex-center-start">
						<span>{{i18n.t('trade.label34')}}</span>
						<span class="label available-balance-text">{{availableBalanceText}} {{availableBalanceUnit}}</span>
						<img
							class="available-balance-eye"
							:src="showAvailableBalance ? eyeUrl2 : eyeUrl"
							:alt="availableBalanceToggleLabel"
							:title="availableBalanceToggleLabel"
							role="button"
							:aria-label="availableBalanceToggleLabel"
							tabindex="0"
							@click.stop="toggleAvailableBalance"
							@keydown.enter.stop.prevent="toggleAvailableBalance"
							@keydown.space.stop.prevent="toggleAvailableBalance"
						>
						<img class="available-balance-transfer" @click="toTransfer" :src="transferUrl2" alt="">
					</div>
					<div>
						{{i18n.t('trade.label35')}}：{{profitMoney}} USDT
					</div>
				</div>

				<div class="bottom-btn">
					<Button :class="upDownType == 1 ? 'green' : 'red'" :disabled="!canSubmitOption" @click="submitOption">{{i18n.t('trade.btn3')}}</Button>
				</div>
			</div>
		</Popup>

		<!--二次确认弹框-->
		<Popup v-model:show="showEnsureModal" position="center" lock-scroll class="ensure-popup">
			<div class="ensure-modal flex-column-center">
				<div class="title" v-if="ensureType == 'option'">{{i18n.t('trade.desc32')}}</div>
				<div class="title" v-if="ensureType == 'cancel' || ensureType == 'cancelContract'">{{i18n.t('trade.desc33')}}</div>
				<div class="flex-center btn-line">
					<Button class="gray" @click="cancel">{{i18n.t('trade.btn1')}}</Button>
					<Button @click="ensureAction">{{i18n.t('trade.btn2')}}</Button>
				</div>
			</div>
		</Popup>
		<!--平仓-->
		<Popup v-model:show="showClearPage" position="bottom" lock-scroll class="rate-popup">
			<clear-page :bitInfo="bitInfo"  :showModal="showClearPage":orderData="orderdetailData" @cancel="cancel" @submit="submitClear"></clear-page>
		</Popup>

		<!--下单确认-->
		<Popup v-model:show="showConfirmModal" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal big2">
				<div class="title flex-center-between">
					<div>{{$t('trade.label48')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>

				<div class="sub-title">
					<div class="flex-center-start">
						<span :class="tradeType == 'buy' ? 'green' : 'red'" v-if="ensureType == 'spot'">
							{{i18n.t(`trade.tab${actionType}`)}}
							{{tradeType == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}
						</span>
						<span :class="ensureData.type == 'long' ? 'green' : 'red'" v-if="ensureType == 'contract'">
							{{i18n.t(`trade.tab${actionType}`)}}
							{{ensureData.type == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}
						</span>
						<span :class="ensureData.type == 1 ? 'green' : 'red'" v-if="ensureType == 'option'">
							{{ensureData.type == 1 ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}
						</span>
						<span class="name">{{bitInfo.ShortName}}</span>
					</div>
				</div>

				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'spot' && actionType == 3">
					<div>{{i18n.t('trade.label5')}}</div>
					<div class="value">{{form.stopPrice}} USDT</div>
				</div>
				<!-- <div class="info-line flex-center-between mt-15">
					<div>{{i18n.t(`trade.${ensureType == 'option' ? 'th19' : 'label4'}`)}}</div>
					<div class="green">{{ensureData.close}} USDT</div>
				</div> -->
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'spot' || ensureType == 'contract'">
					<div>{{i18n.t('trade.label42')}}</div>
					<div class="value">{{ensureData.number}} {{bitInfo.ShortName}}</div>
				</div>
				<!-- <div class="info-line flex-center-between mt-15"  v-if="ensureType == 'spot' || ensureType == 'contract'">
					<div>{{i18n.t('trade.label8')}}</div>
					<div class="value">{{ ensureData.total}} USDT</div>
				</div> -->
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'contract'">
					<div>{{i18n.t('trade.label43')}}</div>
					<div class="value">{{multForm.fullType == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{multForm.multiple}}X</div>
				</div>
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'contract'">
					<div>{{i18n.t('trade.label24')}}</div>
					<div class="value">{{winForm.winMoney || '- -'}}</div>
				</div>
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'contract'">
					<div>{{i18n.t('trade.label27')}}</div>
					<div class="value">{{winForm.loseMoney || '- -'}}</div>
				</div>
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'contract'">
					<div>{{i18n.t('trade.th12')}}</div>
					<div class="yellow">{{getContractClose(ensureData.close, multForm.multiple, ensureData.type)}} USDT</div>
				</div>
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'option'">
					<div>{{i18n.t('trade.label55')}}</div>
					<div class="value">{{ensureData.typeName}}</div>
				</div>
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'option'">
					<div>{{i18n.t('trade.label56')}}</div>
					<div class="value">{{ensureData.money}}USDT</div>
				</div>
				<div class="info-line flex-center-between mt-15" v-if="ensureType == 'option'">
					<div>{{i18n.t('trade.label57')}}</div>
					<div class="value">{{ensureData.profit}}USDT</div>
				</div>

				<!-- <div class="check-line flex-center-start" @click="changeEnsure">
					<img :src="checkedUrl" v-if="!cancelEnsure" alt="">
					<img :src="checkedUrl2" v-if="cancelEnsure" alt="">
					<span>{{$t('trade.label49')}}</span>
				</div> -->

				<div class="modal-btn mt-15">
					<Button v-if="ensureType == 'spot'" class="black"  @click="ensureSubmit">{{tradeType == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}} {{bitInfo.ShortName}}</Button>
					<Button v-if="ensureType == 'contract'"  class="black"  @click="ensureSubmit">{{i18n.t('common.ensure')}}</Button>
					<Button v-if="ensureType == 'option'"  class="black"  @click="ensureSubmit">{{i18n.t('common.ensure')}}</Button>
				</div>
			</div>
		</Popup>

  </div>
</template>

<script>
import { Button, Search, List, Slider, Popup, Picker, Checkbox, Form } from 'vant';
import chartPage from './chart'
import bitPage from '@/components/bit'
import clearPage from './clear'
import { initWebSocket } from '@/utils/common'
import { getToken } from '@/utils/auth'
import { getCoinList, monetaryList } from '@/api/index'
import { userInfo } from '@/api/user'
import { wallet, allTrades, ImitateWallet } from '@/api/assest'
import { spotBuy, futuresSetting, optionOrder, imitateOptionOrder, optionOrderList, imitateOptionOrderList, spotList, cancelSpotOrder, cancelContractOrder, cancelImitateContractOrder, contractOrder, imitateContractOrder, contractList, imitateContractList, tradeHistory, contractSpot, imitateContractSpot, contractLiquidation, imitateContractLiquidation, tradeSetting, updateTradeSetting, getTradeCache } from '@/api/trade'
import { buildOptionOrderFormData, hasValidOptionSetting, normalizeOptionSettings, usesUsdtBalance } from '@/utils/tradeOption'
import moment from 'moment';
import 'moment-timezone';
import { formatServerTimeEn, getServerNow } from '@/utils/timeUtils'
export default {
  name: 'about',
  components: {
    Button,
    Search,
    List,
		Slider,
		Popup,
		Picker,
		Checkbox,
		bitPage,
		chartPage,
		clearPage
  },
	props: {
		modalType: [String, Number]
	},
	computed: {
		availableBalanceAmount() {
			if (this.tabIndex == 0) {
				return this.tradeType == 'buy' ? parseFloat(this.userMoney || 0).toFixed(4) : this.userBitMoney
			}
			if (this.tabIndex == 1) {
				return parseFloat(this.userContractMoney || 0).toFixed(4)
			}
			if (this.tabIndex == 2) {
				return parseFloat(this.userOptionMoney || 0).toFixed(4)
			}
			return '0.0000'
		},
		availableBalanceUnit() {
			if (this.tabIndex == 0 && this.tradeType == 'sell') {
				return this.bitInfo.ShortName
			}
			return 'USDT'
		},
		availableBalanceText() {
			return this.showAvailableBalance ? this.availableBalanceAmount : '****'
		},
		availableBalanceToggleLabel() {
			return this.showAvailableBalance ? '隐藏可用余额' : '显示可用余额'
		},
		previewTotal() {
			if (this.tradeMoney) {
				return parseFloat((this.tradeMoney * this.form.number).toFixed(4))
			}
		},
		buyCount() {
			if (this.bitInfo.count) {
				return (parseFloat(this.userMoney) / parseFloat(this.bitInfo.count)).toFixed(4)
			} else {
				return ''
			}
		},
		currencyVal() {
      return this.$store.state.currencyVal
    },
		saleCount() {
			if (this.bitInfo.count) {
				return (parseFloat(this.userBitMoney) * parseFloat(this.bitInfo.count)).toFixed(4)
			} else {
				return ''
			}
		},
		profitMoney() {
			if (!this.upDownForm.money) {
				return '0.0000'
			} else {
				return (this.upDownForm.money * this.upDownForm.percent / 100).toFixed(4)
			}
		},
		optionSettingLoading() {
			return this.futureLoading && this.timeList.length == 0
		},
		hasOptionSetting() {
			return hasValidOptionSetting(this.futuresObj)
		},
		canSubmitOption() {
			return this.hasOptionSetting && !this.futureLoading && !!this.upDownForm.money
		},
		isSend() {
      return this.$store.state.isSend
    },
		bitList() {
			return this.$store.state.bitList
		},
		modalMenuList() {
			return [
				{
					url: require('../../assets/imgs/menu-setting.png'),
					name: this.$t('trade.menu1'),
					path: 'tradeSetting'
				},
				{
					url: require('../../assets/imgs/menu-order.png'),
					name: this.$t('trade.menu2'),
					path: 'orderList',
					query: {
						type: this.pageType
					}
				},
				// 模拟交易入口 - 暂时隐藏，未来可能重新启用
				// {
				// 	url: require('../../assets/imgs/menu-trade.png'),
				// 	name: this.$t('trade.menu3'),
				// 	path: 'imitate'
				// },
				{
					url: require('../../assets/imgs/menu-order.png'),
					name: this.$t('trade.menu4'),
					path: 'follow'
				},
				{
					url: require('../../assets/imgs/menu-kefu.png'),
					name: this.$t('trade.menu5'),
					path: 'kefu'
				},
			]
		}
	},
  data() {
    return {
			form: {
				dealPrice: '',
				triggerType: 1,
				triggerTypeName: this.i18n.t('trade.label25'),
				limitType: 1,
				limitTypeName: this.i18n.t('trade.label22'),
				setting1: false,
				setting2: false,
				number: '',
				totalMoney: '',
				stopName: this.i18n.t('trade.label24'),
				stop: '1',
				stopPrice: ''
			},
			isModal: false,
			keyword: '',
			pageType: -1,
			newestMoney: 0,
			winForm: {
				tradeType: 'buy',
				winMoney: '',
				loseMoney: '',
				winPercent: 10,
				losePercent: 10
			},
			upDownForm: {
				time: '',
				percent: '',
				money: ''
			},
			multForm: {
				fullType: 'full',
				multiple: 10,
			},
			multList: [10, 20, 50, 100, 200],
			userMoney: '0.0000',
			userContractMoney: '0.0000',
			userOptionMoney: '0.0000',
			userBitMoney: '0.0000',
			userBitContractMoney: '0.0000',
			userBitOptionMoney: '0.0000',
			percentList: [10, 20, 50, 100, 150],
			losePercentList: [10, 20, 30, 50, 90],
			bitUrl: require('../../assets/imgs/icon-bit.png'),
			clearUrl: require('../../assets/imgs/icon-clear.png'),
			moreUrl: require('../../assets/imgs/icon-more.png'),
			addUrl: require('../../assets/imgs/icon-add.png'),
			addUrl2: require('../../assets/imgs/icon-add2.png'),
			addUrl3: require('../../assets/imgs/icon-add3.png'),
			minusUrl: require('../../assets/imgs/icon-minus.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down.png'),
			downUrl2: require('../../assets/imgs/icon-arrow-down2.png'),
			downUrl3: require('../../assets/imgs/icon-arrow-down3.png'),
			defaultUrl: require('../../assets/imgs/icon-default.png'),
			buyUrl: require('../../assets/imgs/icon-buy.png'),
			saleUrl: require('../../assets/imgs/icon-sale.png'),
			orderUrl: require('../../assets/imgs/icon-order.png'),
			rechargeUrl: require('../../assets/imgs/icon-recharge2.png'),
			transferUrl: require('../../assets/imgs/icon-transfer.png'),
			transferUrl2: require('../../assets/imgs/icon-transfer2.png'),
			eyeUrl: require('../../assets/imgs/icon-eye.png'),
			eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
			tradeUrl: require('../../assets/imgs/icon-trade.png'),
			lineUrl: require('../../assets/imgs/icon-line.png'),
			helpUrl: require('../../assets/imgs/icon-help.png'),
			closeUrl: require('../../assets/imgs/icon-close.png'),
			chartUrl: require('../../assets/imgs/icon-chart.png'),
			emptyUrl: require('../../assets/imgs/order-empty.png'),
			warningUrl: require('../../assets/imgs/icon-warning.png'),
			checkedUrl: require('../../assets/imgs/icon-check3.png'),
			checkedUrl2: require('../../assets/imgs/icon-check4.png'),
			tradeType: 'buy', // 买入、卖出
			actionTypeName: this.i18n.t('trade.tab1'), // 交易方式
			actionType: 1,
			tradeMoney: '',//订单价格
			moneySpace: 0.01, // 每次增减金额
			maxSize: 2, // 订单价格小数最大位数
			inputActive: false,
			inputActive2: false,
			inputActive3: false,
			inputActive4: false,
			inputActive5: false,
			inputActive6: false,
			inputActive7: false,
			inputActive8: false,
			showAvailableBalance: true,
			showPreview: false,
			actionTypeList: [],
			actionTypeListBak: [
				{
					value: 1,
					text: this.i18n.t('trade.tab1')
				},
				{
					value: 2,
					text: this.i18n.t('trade.tab2')
				},
				{
					value: 3,
					text: this.i18n.t('trade.tab3')
				},
				// {
				// 	value: 4,
				// 	text: '条件单'
				// },
			],
			triggerTypeList: [
				{
					value: 1,
					text: this.i18n.t('trade.label24')
				},
				{
					value: 2,
					text: this.i18n.t('trade.label27')
				},
			],
			limitTypeList: [
				{
					value: 1,
					text: this.i18n.t('trade.label22')
				},
				{
					value: 2,
					text: this.i18n.t('trade.label21')
				}
			],
			bitInfo: {
				ShortName: 'BTC',
				ID: '1',
				percent: 0,
				count: ''
			},
			tradeMoneyPercent: 0,
			tabIndex: 0,
			cancelEnsure: false,
			showDefault: true,
			showPercent: false,
			showMultiplePercent: false,
			showWinPercent: false,
			showLosePercent: false,
			multiplePercent: 0,
			winPercent: 0,
			losePercent: 0,
			showPickerModal: false,
			showPickerModal2: false,
			showPickerModal3: false,
			showMoreModal: false,
			showUpDownPopup: false,
			showMultModal: false,
			showEnsureModal: false,
			ensureType: '',
			ensureParam: '',
			pickerTop: 0,
			pickerTop2: 0,
			pickerTop3: 0,
			moreTop: 0,
			layout: 0,
			upDealList: [],
      upDealListBak: [],
			allUpDealList: [],
      downDealList: [],
      downDealListBak: [],
			allDownDealList: [],
			deepName: 0.001,// 展示深度
			deepType: 1, // 展示方式
			afterSize: 3, // 展示价格小数位数
			maxValue: 1400, // 展示数量最大值
			minValue: 500, // 展示数量最小值
			deepList: [1, 0.1, 0.01, 0.001],
			typeList: [
				{
					title: this.i18n.t('trade.label36'),
					type: 1,
				},
				{
					title: this.i18n.t('trade.label37'),
					type: 2,
				},
				{
					title: this.i18n.t('trade.label38'),
					type: 3,
				},
			],
			showPopup: false,
			pickerType: '',
			orderTabIndex: 1,
			showAll: false,
			showSetting: false,
			showAllOrder: false,
			showRate: false,
			showBit: false,
			showWinSetting: false,
			showWinInfo: false,
			showWinDesc: false,
			showConfirmModal: false,
			upDownType: '',
			timeList: [],
			client: null, // ws链接client, 内含多个ws连接
			webSocket: null, // 币种价格行情ws
			tradeWs: {}, // 单个币种交易量ws
			futuresObj: null,
			futureLoading: false,
			orderList: [],
			contractOrderList: [],
			optionOrderArr: [],
			historyOptionOrderArr: [], // 历史期权订单数组
			retainedOrderIds: [], // 需要保留在当前订单中的已结算订单ID列表
			retainedOrderTimestamps: {}, // 记录订单保留的时间戳
			isOrderEnsure: true,
			isCancelOrderEnsure: true,
			isSpotEnsure: true, // 现货下单确认
			isOptionEnsure: true, // 期权下单确认
			isContractEnsure: true, // 合约下单确认
			isImitateEnsure: true, // 模拟下单确认
			tradeDataBak: [], // 存放临时交易数据
			timer: '',
			isInitTrade: false, // 防止接口过慢
			isLogin: true,
			setDeep: false,
			upPercentList: [],
			downPercentList: [],
			walletBitList: [],
			allTradesData: [],
			orderTimer: '',
			showClearPage: false,
			orderdetailData: {},
			ensureForm: null,
			ensureData: {},
			marketList: [],
			tradeSettingData: {},
			allRateList: [],
      countdownInterval: null,
			countdownTimer: null, // 倒计时定时器
			balanceTimer: null,
    }
  },
	beforeDestroy() {
    this.$store.state.isSend = false
		if (this.webSocket && this.webSocket.close) {
			this.$store.state.isClose = true
      this.webSocket.close()
    }
		clearInterval(this.timer)
		clearInterval(this.balanceTimer)
		clearTimeout(this.orderTimer)
    this.clearCountdownInterval()
		clearInterval(this.countdownTimer) // 清除倒计时定时器
		// 清理保留订单数据
		this.retainedOrderIds = []
		this.retainedOrderTimestamps = {}
  },
	watch: {
		'$route'() {
			this.initQuery()
		},
		modalType(val) {
			if (val) {
				this.initType()
			}
		}
	},
  mounted() {
		this.initQuery()
		let list = localStorage.getItem('bitList')
		if (list && list != 'undefined' && this.bitList.length == 0) {
			this.$store.state.bitList = JSON.parse(list)
		}
		if (this.bitList.length > 0) {
			this.marketList = [].concat(this.bitList)
		}
		if (this.modalType) {
			this.isModal = true
			this.initType()
		}
		this.initAllTrade()
		this.initSocket()
		this.init()
		this.initTrade()

		this.initFuture()
		this.initOrder()

		this.initConfirm()

		this.initRate()
		this.isLogin = !!getToken()


		let type = localStorage.getItem('fullType')
		let multiple = localStorage.getItem('multiple')
		if (type) {
			this.multForm.fullType = type
		}
		if (multiple) {
			this.multForm.multiple = parseFloat(multiple)
			this.multiplePercent = this.multForm.multiple / 1.25
		}
    if (this.tabIndex === 2) { // 如果默认显示的是期权订单
      this.setupCountdownInterval();
    }
		this.startBalanceTimer()
  },
  methods: {
		initType() { // 切换模拟交易类型
			if (this.modalType == 1) {
				this.tabIndex = 2
			} else if (this.modalType == 2) {
				this.tabIndex = 1
			}
			this.initWallet()
		},
		initRate() {
			monetaryList().then(res => {
				this.allRateList = (res.data && res.data.Items) || []
			})
		},
		initQuery() {
			this.pageType = parseInt(this.$route.query.type)
			switch(this.pageType) {
				case 1: this.tabIndex = 0; break;
				case 2: this.tabIndex = 2; this.setupCountdownInterval(); break;
				case 3: this.tabIndex = 1; break;
				case 4: this.tabIndex = 3; break;
				default: break
			}
			let name = this.$route.query.name
			if (name) {
				this.bitInfo.ShortName = name
				this.bitInfo.ID = this.$route.query.id
			}
		},
		init() {
			if (this.bitList.length == 0) {
        getCoinList().then(res => {
          let bitListBak = res.data.Items
          this.$store.state.bitList = [].concat(bitListBak)
					localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
					this.marketList = [].concat(this.bitListBak)
					let index = this.bitList.findIndex(v => {
						return v.ShortName == this.bitInfo.ShortName
					})
					if (index > -1) {
						this.bitInfo = this.bitList[index]
						this.tradeMoney = this.bitInfo.count
					}
        })
      } else {
				let index = this.bitList.findIndex(v => {
					return v.ShortName == this.bitInfo.ShortName
				})
				if (index > -1) {
					this.bitInfo = this.bitList[index]
					this.tradeMoney = this.bitInfo.count
				}
			}
			//用户余额
			this.initWallet()
			this.initBitMoney()
		},
		initConfirm() {
			tradeSetting().then(res => {
				let data = res.data.Items[0] || {}
				this.tradeSettingData = data
				this.isOptionEnsure = data.OptionOrderConfirm == 1 ? true : false
				this.isContractEnsure = data.FutureOrderConfirm == 1 ? true : false
				this.isSpotEnsure = data.SpotOrderConfirm == 1 ? true : false
				this.isImitateEnsure = data.SimulationOrderConfirm == 1 ? true : false
			})
		},
		initAllTrade() {
      allTrades().then(res => {
        this.allTradesData = res.data
      })
    },
		shouldUseUsdtBalance() {
			return usesUsdtBalance(this.tabIndex, this.tradeType)
		},
		initWallet() {
			if (getToken()) {
				if (this.shouldUseUsdtBalance()) {
					let form = new FormData()
					form.append('current', 1)
					form.append('pageSize', 10)
					form.append('ShortName', 'usdt')
					if (this.modalType) {// 模拟钱包
						ImitateWallet(form).then(res => {
							let data = res.data.Items[0]
							if (data) {
								this.userMoney = data.SpotUse
								this.userOptionMoney = data.OptionUse
								this.userContractMoney = data.ContractUse
							}
						})
					} else {
						wallet(form).then(res => {
							let data = res.data.Items[0]
							if (data) {
								this.userMoney = data.SpotUse
								this.userOptionMoney = data.OptionUse
								this.userContractMoney = data.ContractUse

							}
						})
					}

				} else {
					this.initBitMoney()
				}
			}
		},
		initBitMoney() {
			let form = new FormData()
			form.append('ShortName',  this.bitInfo.ShortName)
			form.append('current', 1)
			form.append('pageSize', 10)
			if (this.modalType) {// 模拟钱包
				ImitateWallet(form).then(res => {
					let data = res.data.Items[0]
					this.walletBitList =  res.data.Items
					if (data) {
						this.userBitMoney = data.SpotUse
						this.userBitOptionMoney = data.OptionUse
						this.userBitContractMoney = data.ContractUse
					}
				})
			} else {
				wallet(form).then(res => {
					let data = res.data.Items[0]
					this.walletBitList =  res.data.Items
					if (data) {
						this.userBitMoney = data.SpotUse
						this.userBitOptionMoney = data.OptionUse
						this.userBitContractMoney = data.ContractUse
					}
				})
			}
		},
		initTrade() {
			// 使用新的缓存接口替换原有的 tradeHistory 接口
			getTradeCache(this.bitInfo.ID).then(res => {
				if (res.data) {
					this.isInitTrade = true
					this.initDealListBak(res.data)
				}
			})
		},
		initFuture() {
			this.futureLoading = true
			futuresSetting().then(res => {
				this.timeList = normalizeOptionSettings(res.data && res.data.Items)
				let data = this.timeList[0]
				if (data) {
					this.changeUpDownPercent(data)
				} else {
					this.futuresObj = null
					this.upDownForm.time = ''
					this.upDownForm.percent = ''
				}
				this.futureLoading = false
			}, () => {
				this.timeList = []
				this.futuresObj = null
				this.upDownForm.time = ''
				this.upDownForm.percent = ''
				this.futureLoading = false
			})
		},
		initOrder() {
			if (!getToken()) {
				return
			}
			clearTimeout(this.orderTimer)

			let form = new FormData()
			form.append('current', 1)
			form.append('pageSize', 20)
			if (this.tabIndex == 0) {
				form.append('Status', '0')
				spotList(form).then(res => {
					this.orderList = res.data.Items
					this.orderTimer = setTimeout(() => {
						this.initOrder()
					}, 3000)
				})
			} else if (this.tabIndex == 1) {
				form.append('Status', '0,1')
				if (this.isModal) {
					imitateContractList(form).then(res => {
						this.contractOrderList = res.data.Items
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				} else {
					contractList(form).then(res => {
						this.contractOrderList = res.data.Items
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				}
			} else if (this.tabIndex == 2) {
				// 当前(进行中)期权订单：不再按"客户端推算的当天时间窗口(Start/End)"过滤。
				// 原因：Start/End 由前端用 getServerNow() 推算的"服务器时区"生成，一旦该时区/时钟与服务端真实落库时区(created_at)不一致，
				//       窗口会整体偏移数小时，把刚下的单挡在窗口外，导致"下单后看不到记录"(线上偶发、本地难复现)。
				// 方案：与现货/合约一致，当前订单只按状态筛选——服务端按 id desc 返回(最新下单必在首页)，
				//       进行中订单由下方 Status==0 过滤决定，已结算订单由 retainedOrderIds 保留逻辑短暂展示。
				if (this.isModal) {
					imitateOptionOrderList(form).then(res => {
						// 检测订单状态变化，如果从Status == 0变成其他状态，添加到保留列表
						this.detectOrderStatusChange(res.data.Items)

						// 显示当前进行中的订单（Status == 0）以及需要保留的已结算订单
						this.optionOrderArr = res.data.Items.filter(item => {
							return item.Status == 0 || this.retainedOrderIds.includes(item.ID)
						})

						// 清理过期的保留订单（5分钟后自动移除）
						this.cleanExpiredRetainedOrders()

						// 调试信息
						console.log(`期权订单更新: 总计${res.data.Items.length}个，当前显示${this.optionOrderArr.length}个，保留${this.retainedOrderIds.length}个已结算订单`)
						if (this.retainedOrderIds.length > 0) {
							console.log('保留的订单ID:', this.retainedOrderIds)
						}

						// 启动倒计时定时器
						this.startCountdownTimer()
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				} else {
					optionOrderList(form).then(res => {
						// 检测订单状态变化，如果从Status == 0变成其他状态，添加到保留列表
						this.detectOrderStatusChange(res.data.Items)

						// 显示当前进行中的订单（Status == 0）以及需要保留的已结算订单
						this.optionOrderArr = res.data.Items.filter(item => {
							return item.Status == 0 || this.retainedOrderIds.includes(item.ID)
						})

						// 清理过期的保留订单（5分钟后自动移除）
						this.cleanExpiredRetainedOrders()

						// 启动倒计时定时器
						this.startCountdownTimer()
						this.orderTimer = setTimeout(() => {
							this.initOrder()
						}, 3000)
					})
				}
			}
		},
		async initSocket(){ //初始化weosocket
      let client = await initWebSocket('all', this.websocketonmessage)
			this.client = client
      this.webSocket = client.ws
			// 订阅交易量数据
			this.tradeWs = this.client.subscribe('/queue/' + this.bitInfo.ShortName.toUpperCase() + '-USDT-trades', message => {
				this.websocketonmessage({
					data: message.body
				});
			})
			this.timer = setInterval(() => {
				this.clearTradeData()
			}, 1000)
    },
		websocketonmessage(e){ //数据接收
      let redata = {}
      try {
        redata = JSON.parse(e.data)
        this.setListData(redata)
      } catch(e) {
      }
    },
		setListData(data) {
			let Amount = data.fields.Amount
			if (!Amount) { //行情
				let index = this.bitList.findIndex(v => {
					return v.ShortName + '-USDT' == data.tags.InstId
				})
				let valObj = data.fields
				let percent = parseFloat(((valObj.Close - valObj.Yesterday) / valObj.Yesterday * 100).toFixed(2))
				if (index > -1) {

					let bitListBak = [].concat(this.bitList)
					bitListBak[index] = {
						...bitListBak[index],
						...valObj,
						percent,
						count: valObj.Close,
					}
					this.$store.state.bitList = [].concat(bitListBak)
					localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
					if (this.bitInfo.ShortName + '-USDT' == data.tags.InstId) {
						this.bitInfo = bitListBak[index]
						if (this.showDefault) {
							// if(this.tradeMoney === '' || this.tradeMoney === undefined) {
							// 	this.tradeMoney = this.bitInfo.count
							// }
						}
						//计算深度列表
						if (!this.setDeep ) {
							this.getDeepList(valObj.Close)
							this.setDeep = true
						}
						this.newestMoney = parseFloat(valObj.Close)
            this.updateChart(this.newestMoney, getServerNow().valueOf())
					}
					if (this.keyword) {
						this.marketList = bitListBak.filter(v => {
							return v.ShortName.toLowerCase().indexOf(this.keyword) > -1
						})
					} else {
						this.marketList = [].concat(bitListBak)
					}
				} else {
					this.bitInfo.percent = percent
					this.bitInfo.count = valObj.Close
					this.newestMoney = parseFloat(valObj.Close)
          this.updateChart(this.newestMoney, getServerNow().valueOf())
				}
			} else {//交易量
				this.isInitTrade = true
				if ((this.bitInfo.ShortName + '-USDT') == data.tags.InstId) {
          this.updateChart(parseFloat(data.fields.Price), getServerNow().valueOf())
					let type = data.fields.Side
					let param = {
						value: data.fields.Price,
						val: parseFloat(data.fields.Price),
						dealCount: this.resetCount(parseFloat(data.fields.Amount)),
						count: data.fields.Amount,
						time: getServerNow().valueOf(),
						type: type
					}
					this.tradeDataBak.push(param)
					let totalList = this.tradeDataBak.filter(v => {
						return v.value == param.value && v.type == param.type
					})
					let total = 0
					totalList.forEach(v => {
						total += parseFloat(v.count)
					})
					total = parseFloat(total.toFixed(8))
					let newParam = {
						...param,
						dealCount: this.resetCount(total),
						count: total,
						time: getServerNow().valueOf(),
					}
					//价格从高到低排列
					if (type == 'Sell') {
						let index = this.allUpDealList.findIndex(v => {
							return v.value == data.fields.Price
						})
						if (index > -1) {
							this.allUpDealList.splice(index, 1, newParam)
						} else {
							this.allUpDealList.push(newParam)
						}

						this.allUpDealList.sort((a, b) => {
							return b.val - a.val
						})
					} else {
						let index = this.allDownDealList.findIndex(v => {
							return v.value == data.fields.Price
						})
						if (index > -1) {
							this.allDownDealList.splice(index, 1, newParam)
						} else {
							this.allDownDealList.push(newParam)
						}
						this.allDownDealList.sort((a, b) => {
							return b.val - a.val
						})
					}

					this.upDealListBak = this.allUpDealList.filter(v => {
						return v.val >= parseFloat(this.bitInfo.count)
					})
					this.downDealListBak = this.allDownDealList.filter(v => {
						return v.val <= parseFloat(this.bitInfo.count)
					})

					if (this.upDealListBak.length < 6) {
						this.upDealListBak = this.allUpDealList.slice(0, 6)
					}
					if (this.downDealListBak.length < 6) {
						this.downDealListBak = this.allDownDealList.slice(this.allDownDealList.length - 6)
					}


					if (this.downDealListBak.length < 16) {
						let size = 16 - this.downDealListBak.length
						let emptyArr = []
						for(let i = 0; i < size; i++) {
							emptyArr.push({
								value: '--',
								val: 0,
								dealCount: '--',
								count: 0
							})
						}
						this.downDealListBak = this.downDealListBak.concat(emptyArr)
					}
					this.initDealList()
				}
			}
		},
		clearTradeData() {
			let now = getServerNow().valueOf()
			//保留3s内数据
			this.tradeDataBak = this.tradeDataBak.filter(v => {
				return v.time && now - v.time < 3000
			})
		},
		getDeepList(price) {
			let str = price + ''
			let afterSize = str.length - str.indexOf('.') - 1
			if (afterSize < 2) {
				afterSize = 2
			}
			let list = []
			for(let i = 0; i < 4; i++) {
				let val = 10 / Math.pow(10, afterSize - 2 + i)
				if (val < 1) {
					val = val.toFixed(afterSize - 3 + i)
				}
				list.push(val)
			}
			this.deepList = list
			this.deepName = this.deepList[3] + ''
			this.afterSize = this.deepName.length - this.deepName.indexOf('.') - 1
		},
		toPath(path, query) {
			this.$router.push({
				name: path,
				query: query ? query : {}
			})
		},
    changeTab(i) {
			this.tabIndex = i
			this.orderTabIndex = 1
			this.initDealList()
			this.initOrder()
      this.updateQueryParam('type', i)
      localStorage.setItem('tabIndex', i)
      if (i === 2) { // 期权交易
        this.$nextTick(() => {
          this.setupCountdownInterval();
        });
      } else {
        this.clearCountdownInterval();
				// 清除倒计时定时器
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
      }
		},
    changeType(type) {
			this.tradeType = type
			this.tradeMoneyPercent = 0
			this.form.number = ''
			this.form.totalMoney = ''
			//刷新钱包数据
			this.initWallet()
		},
		toggleAvailableBalance() {
			this.showAvailableBalance = !this.showAvailableBalance
		},
		dragStart() {
			this.showPercent = true
		},
		dragEnd() {
			this.showPercent = false
		},
		dragMultipleStart() {
			this.showMultiplePercent = true
		},
		dragMultipleEnd() {
			this.showMultiplePercent = false
		},
		dragWinStart() {
			this.showWinPercent = true
		},
		dragWinEnd() {
			this.showWinPercent = false
		},
		dragLoseStart() {
			this.showLosePercent = true
		},
		dragLoseEnd() {
			this.showLosePercent = false
		},
		addMoney() {
			let newMoney = this.moneySpace + parseFloat(this.tradeMoney) || 0
			this.tradeMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
			this.changeMoney()
		},
		minusMoney() {
			let newMoney =  parseFloat(this.tradeMoney) - this.moneySpace || 0
			if (newMoney < 0) {
				newMoney = 0
			}
			this.tradeMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
			this.changeMoney()
		},
		showPicker() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.trade-type')
			let top = dom.offsetTop
			this.pickerTop = top - scrollTop
			if (this.tabIndex == 0) {
				this.actionTypeList = this.actionTypeListBak.slice(0, 2)
			} else {
				this.actionTypeList = this.actionTypeListBak.slice(0, 3)
			}
			this.showPickerModal = true
		},
		showPicker2() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.trigger-dom')
			let top = dom.offsetTop
			this.pickerTop2 = top - scrollTop
			this.showPickerModal2 = true
		},
		showPicker3() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.limit-dom')
			let top = dom.offsetTop
			this.pickerTop3 = top - scrollTop
			this.showPickerModal3 = true
		},
		showMore() {
			let scrollTop = document.querySelector('.trade-page').scrollTop
			let dom = document.querySelector('.trade-info')
			let top = dom.offsetTop
			this.moreTop = top - scrollTop
			if (this.moreTop < -10) {
					this.moreTop = -10
			}
			this.showMoreModal = true
		},
		changeActionType(data) {
			this.actionType = data.value
			this.actionTypeName = data.text
			this.showPickerModal = false
			this.initDealList()
			if (data.value == 1 || data.value == 3) {
				this.showDefault = true
				this.tradeMoney = this.bitInfo.count
			}
			if (data.value != 3) {
				this.winForm = {
					tradeType: 'buy',
					winMoney: '',
					loseMoney: '',
					winPercent: 10,
					losePercent: 10
				}
			}
		},
		changeTriggerType(data) {
			this.form.stop = data.value
			this.form.stopName = data.text
			this.showPickerModal2 = false
		},
		changeLimitType(data) {
			this.form.limitType = data.value
			this.form.limitTypeName = data.text
			this.showPickerModal3 = false
			this.tradeMoney = this.bitInfo.count
			this.showDefault = true
			this.changeMoney()
		},
		cancel() {
			this.showPickerModal = false
			this.showPickerModal2 = false
			this.showPickerModal3 = false
			this.showMoreModal = false
			this.showSetting = false
			this.showRate = false
			this.showBit = false
			this.showWinInfo = false
			this.showWinSetting = false
			this.showPopup = false
			this.showAllOrder = false
			this.showUpDownPopup = false
			this.showMultModal = false
			this.showEnsureModal = false
			this.showClearPage = false
			this.showConfirmModal = false
		},
		showDeepPicker() {
			this.showPopup = true
			this.pickerType = 'deep'
		},
		showTypePicker() {
			this.showPopup = true
			this.pickerType = 'type'
		},
		onConfirm() {
			this.showPopup = false
		},
		initDealList() {
			let size = 12
      switch(this.actionType) {
        case 1: size = 12; break;
        case 2: size = 10; break;
        case 3: size = 14; break;
        case 4: size = 16; break;
        default: break
      }
			if (this.tabIndex == 1) {
				size -= 2
			}
			let upBeginSize = 0
			if (this.deepType == 1) {
				upBeginSize = this.upDealListBak.length - size / 2
			} else {
				upBeginSize = this.upDealListBak.length - size
			}
			if (upBeginSize < 0) {
				upBeginSize = 0
			}
      switch(this.deepType) {
        case 1: this.upDealList = this.upDealListBak.slice(upBeginSize, this.upDealListBak.length); this.downDealList = this.downDealListBak.slice(0,  size / 2); break;
        case 2: this.upDealList = []; this.downDealList = this.downDealListBak.slice(0, size); break;
        case 3: this.upDealList = this.upDealListBak.slice(upBeginSize, this.upDealListBak.length); this.downDealList = []; break;
        default: break
      }
			// this.upDealList.reverse()
    },
		checkPrice(data) {
			// if (this.form.limitType == 2) {
			// 	return
			// }
			this.tradeMoney = this.resetValue(data.value)
      this.form.dealPrice = this.resetValue(data.value)
			this.showDefault = false
			if (this.form.number) {
				this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
			}
    },
		initDealListBak(data) {
			let buyList = data.buy
			let sellList = data.sell
			buyList.forEach(v => {
				// 恢复价格去重逻辑，Order Form区域按价格聚合显示
				let index = this.allUpDealList.findIndex(val => {
					return v.Price == val.value  // 查找是否已存在相同价格
				})
				if (index === -1) {  // 只有价格不存在时才添加
					this.allUpDealList.push({
						value: v.Price,
						val: parseFloat(v.Price),
						dealCount: this.resetCount(parseFloat(v.Amount)),
						count: parseFloat(v.Amount)
					})
				} else {
					// 如果价格已存在，累加数量
					this.allUpDealList[index].count += parseFloat(v.Amount)
					this.allUpDealList[index].dealCount = this.resetCount(this.allUpDealList[index].count)
				}
			})
			sellList.forEach(v => {
				// 恢复价格去重逻辑，Order Form区域按价格聚合显示
				let index = this.allDownDealList.findIndex(val => {
					return v.Price == val.value  // 查找是否已存在相同价格
				})
				if (index === -1) {  // 只有价格不存在时才添加
					this.allDownDealList.push({
						value: v.Price,
						val: parseFloat(v.Price),
						dealCount: this.resetCount(parseFloat(v.Amount)),
						count: parseFloat(v.Amount)
					})
				} else {
					// 如果价格已存在，累加数量
					this.allDownDealList[index].count += parseFloat(v.Amount)
					this.allDownDealList[index].dealCount = this.resetCount(this.allDownDealList[index].count)
				}
			})

			this.allUpDealList.sort((a, b) => {
				return b.val - a.val
			})
			this.allDownDealList.sort((a, b) => {
				return b.val - a.val
			})

			this.upDealListBak = this.allUpDealList.filter(v => {
				return v.val >= parseFloat(this.bitInfo.count)
			})
			this.downDealListBak = this.allDownDealList.filter(v => {
				return v.val <= parseFloat(this.bitInfo.count)
			})

			if (this.upDealListBak.length < 6) {
				this.upDealListBak = this.allUpDealList.slice(0, 6)
			}
			if (this.downDealListBak.length < 6) {
				this.downDealListBak = this.allDownDealList.slice(this.allDownDealList.length - 6)
			}
			this.initDealList()
    },
		getSpace() {
			let space = this.deepName
			return space
		},
		resetValue(val) {
			if (isNaN(val)) {
				return val
				} else {
				if (this.afterSize > 0) {
					return parseFloat(val).toFixed(this.afterSize)
				} else if (this.afterSize == 0) {
					return parseInt(val)
				} else {
					return parseInt(val / Math.pow(10, -this.afterSize)) * Math.pow(10, - this.afterSize)
				}
			}
		},
		resetCount(value) {
			let size = 5
			if (value > 10000000) {
				let newNum = value / 1000 / 1000
				return newNum.toFixed(2) + 'M'
			} else if (value > 10000) {
				let newNum = value / 1000
				return newNum.toFixed(2) + 'K'
			} else if (value > 1) {
				let numStr = value + ''
				let beforeSize = numStr.substring(0, numStr.indexOf('.')).length
				let afterSize = size - beforeSize
				return value.toFixed(afterSize)
			} else {
				return parseFloat(value)
			}
		},
		getBgWidth(val, index, type) {
			let data = type == 1 ? this.upPercentList : this.downPercentList
			let dataBak = data[index]
			let max = 100
			if (type == 1) {
				max = 100 - index * 10
			} else {
				max = 50 + index * 10
			}
			if (max > 100) {
				max = 100
			}

			if (!dataBak) {
				let percent = Math.random() * max
				data[index] = {
					val: val,
					width: percent
				}
				return `width: ${val ? percent : 0}%;`
			} else {
				if (val != dataBak.val) {
					let percent = Math.random() * max
					data[index] = {
						val: val,
						width: percent
					}
					return `width: ${val ? percent : 0}%;`
				} else {
					return `width: ${dataBak.width}%;`
				}
			}
		},
		changeDeep(val) {
			this.deepName = val
			let str = val + ''
			if (str.indexOf('.') > -1) {
				this.afterSize = str.length - str.indexOf('.') - 1
			} else {
				this.afterSize = 1 - str.length
			}
			this.showPopup = false
		},
		changeDeepType(data) {
			this.deepType = data.type
			this.showPopup = false
			this.initDealList()
		},
		changeOrderTab(i) {
			this.orderTabIndex = i
			clearTimeout(this.orderTimer)
			if (i != 2) {
				this.initOrder()
			} else {
				this.initBitMoney()
			}
		},
		toInfo(type) {
			if (type == 'trade') {
				this.showSetting = true
			} else {
				this.showRate = true
			}
			this.showMoreModal = false
		},
		changeBit() {
			this.showBit = true

		},
		chooseBit(data) {
			//取消之前订阅交易量数据
			this.client.unsubscribe(this.tradeWs.id)

			//清空交易数据
			this.upDealListBak = []
			this.downDealListBak = []
			this.allDownDealList = []
			this.allUpDealList = []

			this.bitInfo = data
			this.tradeMoney = this.bitInfo.count
			this.showDefault = true
			this.showBit = false
			this.isInitTrade = false
			this.initTrade()
			this.init()

			// 订阅新的交易量数据
			this.tradeWs = this.client.subscribe('/queue/' + this.bitInfo.ShortName.toUpperCase() + '-USDT-trades', message => {
				this.websocketonmessage({
					data: message.body
				});
			})
			this.setDeep = false
		},
		changeWinSetting() {
			this.showWinSetting = true
			if (!this.winForm.winMoney) {
				this.winForm.winMoney = (this.bitInfo.count * 1.1).toFixed(this.maxSize)
				this.winForm.loseMoney = (this.bitInfo.count * 0.9).toFixed(this.maxSize)
			}
		},
		saveWinSetting() {
			this.showBit = false
		},
		changeWinType(type) {
			this.winForm.tradeType = type
		},
		changeFullType(type) {
			this.multForm.fullType = type
		},
		changeMultiple(mult) {
			this.multForm.multiple = mult
		},
		checkWinMoney(type) {
			return
			if (type == 1) {
				this.inputActive7 = false
				let newMoney = parseFloat(this.winForm.winMoney)
				this.winForm.winMoney = parseFloat((newMoney).toFixed(this.maxSize))
				// if (this.winForm.winMoney < this.bitInfo.count) {
				// 	this.winForm.winMoney = this.bitInfo.count
				// }
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				this.inputActive8 = false
				let newMoney = parseFloat(this.winForm.loseMoney)
				this.winForm.loseMoney = parseFloat((newMoney).toFixed(this.maxSize))
				// if (this.winForm.loseMoney > this.bitInfo.count) {
				// 	this.winForm.loseMoney = this.bitInfo.count
				// }
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		addWinMoney(type) {
			if (type == 1) {
				let newMoney = this.moneySpace + parseFloat(this.winForm.winMoney) || 0
				this.winForm.winMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				let newMoney = this.moneySpace + parseFloat(this.winForm.loseMoney) || 0
				this.winForm.loseMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				if (this.winForm.loseMoney > this.bitInfo.count) {
					this.winForm.loseMoney = this.bitInfo.count
				}
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		minusWinMoney(type) {
			if (type == 1) {
				let newMoney =  parseFloat(this.winForm.winMoney) - this.moneySpace || 0
				if (newMoney < 0) {
					newMoney = 0
				}
				this.winForm.winMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				if (this.winForm.winMoney < this.bitInfo.count) {
					this.winForm.winMoney = this.bitInfo.count
				}
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				let newMoney =  parseFloat(this.winForm.loseMoney) - this.moneySpace || 0
				if (newMoney < 0) {
					newMoney = 0
				}
				this.winForm.loseMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		changePercent(val, type) {
			if (type == 1) {
				this.winForm.winPercent = val
				this.winPercent = this.winForm.winPercent / 1.5
				if (this.winData && this.winData.Direction == 'short') {//做空
					this.winForm.winMoney = (this.bitInfo.count * (1 - val / 100)).toFixed(this.maxSize)
				} else {
					this.winForm.winMoney = (this.bitInfo.count * (1 + val / 100)).toFixed(this.maxSize)
				}
			} else {
				this.winForm.losePercent = val
				this.losePercent = this.winForm.losePercent / 0.9
				if (this.winData && this.winData.Direction == 'short') {//做空
					this.winForm.loseMoney = (this.bitInfo.count * (1 + val / 100)).toFixed(this.maxSize)
				} else {
					this.winForm.loseMoney = (this.bitInfo.count * (1 - val / 100)).toFixed(this.maxSize)
				}
			}
		},
		showDetail() {
			this.showWinDesc = !this.showWinDesc
		},
		showOrder() {
			if (!getToken()) {
				this.toPath('login')
				return
			}
			sessionStorage.setItem('bitInfo', JSON.stringify(this.bitInfo))
			this.$router.push({
				name: 'orderList',
				query: {
					type: this.isModal ? (parseInt(this.modalType) + 3) : this.pageType
				}
			})
		},
		showUpDownModal(type) {
			this.upDownType = type
			this.upDownForm.money = ''
			if (!this.futureLoading && !this.timeList.length) {
				this.$toast.fail(this.i18n.t('trade.error1'))
				return
			}
			this.showUpDownPopup = true
			if (this.futureLoading) {
				return
			}
			// this.changeUpDownPercent(this.timeList[0])
			this.changeUpDownPercent(hasValidOptionSetting(this.futuresObj) ? this.futuresObj : this.timeList[0])
		},
		changeUpDownPercent(data) {
			if (!hasValidOptionSetting(data)) {
				return
			}
			this.futuresObj = data
			this.upDownForm.time = data.Time
			this.upDownForm.percent = data.ProfitRatio
		},
		ensureSubmit() {
			this.showConfirmModal = false
			if (this.cancelEnsure) {//不再提示
				if (this.pageType == 1) { // 现货
					this.isSpotEnsure = false
					this.tradeSettingData.SpotOrderConfirm = 2
				} else if (this.pageType == 2) { // 期权
					this.isOptionEnsure = false
					this.tradeSettingData.OptionOrderConfirm = 2
				} else if (this.pageType == 3) { // 合约
					this.isContractEnsure = false
					this.tradeSettingData.FutureOrderConfirm = 2
				} else if (this.isModal) { // 模拟
					this.isImitateEnsure = false
					this.tradeSettingData.SimulationOrderConfirm = 2
				}
				this.updateSetting()
			}
			if (this.ensureType == 'spot') {
				this.doSubmit(this.ensureForm)
			} else if (this.ensureType == 'contract') {
				this.doSubmitContract(this.ensureForm)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			}
		},
    updateChart(price, time) {
      if (this.$refs.chartPage && this.$refs.chartPage.updateLastPriceLine) {
          // A. Update line
          this.$refs.chartPage.updateLastPriceLine(price);

          // B. Update Bar
          const chart = this.$refs.chartPage;
          const timeframe = chart.echartsTime;
          
          const moment = require('moment-timezone');
          const serverTimezone = this.$store.state.timeZone;
          
          // Parse time with Server Timezone
          let m = moment.tz(time, serverTimezone);

          // Normalize based on timeframe
          if (timeframe == 'm1') m.startOf('minute');
          else if (timeframe == 'm3') { 
              let min = m.minute(); 
              m.minute(min - min % 3).startOf('minute'); 
          }
          else if (timeframe == 'm5') { 
              let min = m.minute(); 
              m.minute(min - min % 5).startOf('minute'); 
          }
          else if (timeframe == 'm15') { 
              let min = m.minute(); 
              m.minute(min - min % 15).startOf('minute'); 
          }
          else if (timeframe == 'm30') { 
              let min = m.minute(); 
              m.minute(min - min % 30).startOf('minute'); 
          }
          else if (timeframe == 'h1') m.startOf('hour');
          else if (timeframe == 'h4') {
              let h = m.hour();
              m.hour(h - h % 4).startOf('hour');
          }
          
          const periodStart = m.valueOf(); 
          // Format using the same format as chart.vue init() logic: 'MM-DD HH:mm'
          // Since m is already in serverTimezone, format() will output correctly aligned with chart x-axis
          let periodStartStr = m.format('MM-DD HH:mm'); 

          // Get last bar from chart
          let lastBar = null;
          if (chart.kLineData && chart.kLineData.length > 0) {
              lastBar = chart.kLineData[chart.kLineData.length - 1];
          }

          let open, high, low, close;
          close = price;
          
          // Compare formatted time string to check if it's the same bar
          if (lastBar && lastBar.UpdatedAt === periodStartStr) {
              open = lastBar.Open;
              high = Math.max(lastBar.High, price);
              low = Math.min(lastBar.Low, price);
          } else {
              open = price;
              high = price;
              low = price;
          }
          
          const bar = {
              Time: periodStart,
              Open: open,
              High: high,
              Low: low,
              Close: close,
              Volume: 0 
          };
          
          chart.updateStreamingBar(bar);
      }
    },
		updateSetting() {
			let form = new FormData()
			form.append('OptionOrderConfirm', this.tradeSettingData.OptionOrderConfirm)
			form.append('FutureOrderConfirm', this.tradeSettingData.FutureOrderConfirm)
			form.append('FollowOrderConfirm', this.tradeSettingData.FollowOrderConfirm)
			form.append('SpotOrderConfirm', this.tradeSettingData.SpotOrderConfirm)
			form.append('FinanceOrderConfirm', this.tradeSettingData.FinanceOrderConfirm)
			form.append('SimulationOrderConfirm', this.tradeSettingData.SimulationOrderConfirm)
			updateTradeSetting(form).then(res => {})
		},
		startBalanceTimer() {
			this.balanceTimer = setInterval(() => {
				this.refreshBalance()
			}, 3000)
		},
		refreshBalance() {
			if (!getToken()) return
			this.initWallet()
			if (this.shouldUseUsdtBalance()) {
				this.initBitMoney()
			}
		},
		submit() {
			if (!this.form.number) {
				this.$toast.fail( this.i18n.t('trade.error3'))
				return
			}
			if ((this.actionType == 1 || this.actionType == 3) && !this.tradeMoney) {
				this.$toast.fail(this.i18n.t('trade.error4'))
				return
			}
			// if (this.actionType == 2 && this.tradeType == 'buy' && !this.form.totalMoney) {
			// 	this.$toast.fail(this.i18n.t('trade.error5'))
			// 	return
			// }
			if (this.actionType == 3 && !this.form.stopPrice) {
				this.$toast.fail(this.i18n.t('trade.error7'))
				return
			}
			let Trust = ''
			let number = 0
			let close = 0
			let total = 0
			let stop = ''
			let stopPrice = 0
			if (this.actionType == 1) { // 限价交易
				Trust = 'limit'
				number = this.form.number
				total = this.form.totalMoney
				close = this.tradeMoney
			}
			if (this.actionType == 2) { // 市价交易
				Trust = 'market'
				total = this.form.number * this.newestMoney
				number = this.form.number
				close = this.newestMoney
			}
			if (this.actionType == 3) { // 止盈止损
				Trust = this.form.limitType == 1 ? 'limit' : 'market'
				stop = this.form.stop
				stopPrice = this.form.stopPrice
				number = this.form.number
				total = this.form.totalMoney
				close = this.tradeMoney
				// if (this.form.limitType == 1) {
				// } else {
				// 	total = this.form.totalMoney
				// 	number = this.form.number
				// 	close = this.newestMoney
				// }
			}
			let form = new FormData()
			form.append('Trust', Trust)
			form.append('CurrencyId', this.bitInfo.ID)
			form.append('Trade', this.tradeType)
			form.append('Number', number)
			form.append('Stop', stop)
			form.append('StopPrice', stopPrice)
			form.append('TrustNum', number)
			form.append('TrustClose', total)
			form.append('Close', close)

			if (this.isSpotEnsure || (this.isModal && this.isImitateEnsure)) {
				this.ensureType = 'spot'
				this.showConfirmModal = true
				this.ensureForm = form
				this.ensureData = {
					total: total,
					number: number,
					close: close,
				}
			} else {
				this.doSubmit(form)
			}
		},

		doSubmit(form) {
			spotBuy(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
					this.initOrder()
					setTimeout(() => {
						this.initWallet()
					}, 500)
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		submitContract(type) {

			if (!this.form.number) {
				this.$toast.fail(this.i18n.t('trade.error3'))
				return
			}
			if ((this.actionType == 1 || this.actionType == 3) && !this.tradeMoney) {
				this.$toast.fail(this.i18n.t('trade.error4'))
				return
			}

			if (type == 'long') {
				// 做多情况下，止盈 > 订单价格 > 止损
				if (this.actionType == 3) {
					if (this.tradeMoney > this.winForm.winMoney) {
						this.$toast.fail(this.$t('trade.label68'))
						return
					}
					if (this.tradeMoney < this.winForm.loseMoney) {
						this.$toast.fail(this.$t('trade.label69'))
						return
					}
				}
			} else {
					// 做空情况下，止盈 < 订单价格 < 止损
				if (this.actionType == 3) {
					if (this.tradeMoney < this.winForm.winMoney) {
						this.$toast.fail(this.$t('trade.label70'))
						return
					}
					if (this.tradeMoney > this.winForm.loseMoney) {
						this.$toast.fail(this.$t('trade.label71'))
						return
					}
				}
			}

			let Trust = ''
			let number = 0
			let close = 0
			let total = 0
			let takeProfit = ''
			let stopLoss = ''
			if (this.actionType == 1) { // 限价交易
				Trust = 'limit'
				number = this.form.number
				// total = this.form.number * this.tradeMoney
				total = this.form.totalMoney
				close = this.tradeMoney
			}
			if (this.actionType == 2) { // 市价交易
				Trust = 'market'
				total = this.form.number * this.newestMoney
				number = this.form.number
				close = this.newestMoney
			}
			if (this.actionType == 3) { // 止盈止损
				Trust = this.form.limitType == 1 ? 'limit' : 'market'
				number = this.form.number
				// total = number * (this.form.limitType == 1 ? this.tradeMoney : this.newestMoney)
				total = this.form.totalMoney
				takeProfit = this.winForm.winMoney
				stopLoss = this.winForm.loseMoney
				close = this.tradeMoney
				// close = this.form.limitType == 1 ? this.tradeMoney : this.newestMoney
			}
			let form = new FormData()
			form.append('CurrencyID', this.bitInfo.ID)
			form.append('Trust', Trust)
			form.append('Direction', type)
			form.append('Multiple', this.multForm.multiple)
			form.append('Full', this.multForm.fullType)
			form.append('TakeProfit', takeProfit)
			form.append('StopLoss', stopLoss)
			form.append('Close', close)

			// form.append('TrustNum', number)
			// form.append('TrustClose', total)

			form.append('MarketPrice', total)
			form.append('Num', number)

			if (this.isContractEnsure || (this.isModal && this.isImitateEnsure)) {
				this.ensureType = 'contract'
				this.showConfirmModal = true
				this.ensureForm = form
				this.ensureData = {
					type: type,
					total: total,
					number: number,
					close: close,
				}
			} else {
				this.doSubmitContract(form)
			}
		},
		doSubmitContract(form) {
			if (this.isModal) {
				imitateContractOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						this.initOrder()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				contractOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						this.initOrder()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		submitOption() {
			if (!hasValidOptionSetting(this.futuresObj)) {
				this.$toast.fail(this.i18n.t('trade.error1'))
				return
			}
			if (!this.upDownForm.money) {
				this.$toast.fail(this.i18n.t('trade.error2'))
				return
			}
			if (this.isOptionEnsure || (this.isModal && this.isImitateEnsure)) {
				this.showConfirmModal = true
				this.ensureType = 'option'
				this.ensureData = {
					type: this.upDownType,
					money: this.upDownForm.money,
					close: this.bitInfo.count,
					typeName: this.upDownForm.time + 'S ' + this.upDownForm.percent + '%',
					profit: this.profitMoney
				}
			} else {
				this.doSubmitOption()
			}
		},
		doSubmitOption() {
			if (!hasValidOptionSetting(this.futuresObj)) {
				this.$toast.fail(this.i18n.t('trade.error1'))
				return
			}
			if (!this.upDownForm.money) {
				this.$toast.fail(this.i18n.t('trade.error2'))
				return
			}
			let form
			try {
				form = buildOptionOrderFormData({
					bitInfo: this.bitInfo,
					amount: this.upDownForm.money,
					upDownType: this.upDownType,
					futuresObj: this.futuresObj
				})
			} catch (error) {
				this.$toast.fail(this.i18n.t('trade.error1'))
				return
			}
			if (this.isModal) {
				imitateOptionOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						this.showUpDownPopup = false
						this.initOrder()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				optionOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t(`trade.success4_${this.pageType}`))
						this.showUpDownPopup = false
						this.initOrder()
						this.initWallet()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		cancelContract(data) {
			this.showEnsureModal = true
			this.ensureParam = data
			this.ensureType = 'cancelContract'
		},
		doCancelContract(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			if (this.isModal) {
				cancelImitateContractOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success2'))
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				cancelContractOrder(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success2'))
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		cancelOrder(data) {
			if (this.isCancelOrderEnsure) {
				this.showEnsureModal = true
				this.ensureParam = data
				this.ensureType = 'cancel'
			} else {
				this.doCancelOrder(data)
			}
		},
		doCancelOrder(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelSpotOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		ensureMult() {
			this.showMultModal = false
			if (this.multForm.multiple < 1) {
				this.multForm.multiple = 1
			}
			localStorage.setItem('fullType', this.multForm.fullType)
			localStorage.setItem('multiple', this.multForm.multiple)
		},
		changeMultSetting() {
			this.showMultModal = true
		},
		ensureWin() {

			if (this.showWinInfo) {
				this.showWinInfo = false
				//更改止盈止损价格
				let form = new FormData()
				form.append('ID', this.winData.ID)
				form.append('TakeProfit', this.winForm.winMoney)
				form.append('StopLoss', this.winForm.loseMoney)
				if (this.isModal) {
					imitateContractSpot(form).then(res => {
						if (res.code == 0) {
							this.$toast.success(this.i18n.t('trade.success3'))
							this.initOrder()
							this.showWinSetting = false
						} else {
							this.$toast.fail(res.msg)
						}
					})
				} else {
					contractSpot(form).then(res => {
						if (res.code == 0) {
							this.$toast.success(this.i18n.t('trade.success3'))
							this.initOrder()
							this.showWinSetting = false
						} else {
							this.$toast.fail(res.msg)
						}
					})
				}
			} else {
				this.showWinSetting = false
			}
		},
		changeTotal() {
			if (this.tradeMoney) {
				this.form.number = parseFloat((this.form.totalMoney / this.tradeMoney).toFixed(6))
			} else {
				if (this.form.number) {
					this.tradeMoney =  parseFloat((this.form.totalMoney / this.form.number).toFixed(6))
				}
			}
		},
		changeCount() {
			if (this.tradeMoney) {
				this.showPreview = true
				this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
			} else {
				if (this.form.totalMoney) {
					this.tradeMoney = parseFloat((this.form.totalMoney / this.form.number).toFixed(6))
				}
			}

		},
		changeMoney() {
			if (this.form.number) {
				this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
			} else {
				if (this.form.totalMoney) {
					this.form.number = parseFloat((this.form.totalMoney / this.tradeMoney).toFixed(6))
				}
			}
		},
		changeSlide(val) {
			if (this.tradeType == 'buy') {
				let money = this.tabIndex == 0 ? this.userMoney : (this.tabIndex == 1 ? this.userContractMoney : this.userOptionMoney)
				this.form.totalMoney = money * (val / 100)
				if (this.tradeMoney) {
					this.form.number = parseFloat((this.form.totalMoney / this.tradeMoney).toFixed(6))
				} else {
					if (this.form.number) {
						this.tradeMoney =  parseFloat((this.form.totalMoney / this.form.number).toFixed(6))
					}
				}
			} else {
				let money = this.tabIndex == 0 ? this.userBitMoney : (this.tabIndex == 1 ? this.userBitContractMoney : this.userBitOptionMoney)
				this.form.number = money * (val / 100)
				if (this.tradeMoney) {
					this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
				} else {
					if (this.form.totalMoney) {
						this.tradeMoney =  parseFloat((this.form.totalMoney / this.form.number).toFixed(6))
					}
				}
			}
		},
		changeMultipleSlide(val) {
			this.multiplePercent = val / 1.25
		},
		changeWinPercent(val) {
			this.winPercent = val / 1.5
			this.changePercent(val, 1)
		},
		changeLosePercent(val) {
			this.losePercent = val / 0.9
			this.changePercent(val, 2)
		},
		ensureAction() {
			this.showEnsureModal = false
			if (this.ensureType == 'cancel') {
				this.doCancelOrder(this.ensureParam)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			} else if (this.ensureType == 'cancelContract') {
				this.doCancelContract(this.ensureParam)
			}
		},
		changeEnsure() {
			this.cancelEnsure = !this.cancelEnsure
		},
		//设置止盈止损
		setWinOrLose(data) {
			this.showWinSetting = true
			this.showWinInfo = true
			this.winData = Object.assign({}, data)
			this.winForm.winMoney = data.TakeProfit ? data.TakeProfit.toFixed(this.maxSize) : ''
			this.winForm.loseMoney = data.StopLoss ? data.StopLoss.toFixed(this.maxSize) : ''
		},
		resetSpotMoney(count, id) {
      let index = this.allTradesData.findIndex(v => {
        return v.CurrencyId == id
      })
      if (index > -1) {
        let price = this.allTradesData[index].Price
        return parseFloat(price * count).toFixed(4)
      } else {
        return parseFloat(count).toFixed(4)
      }
    },
		toClearOrder(data) {
			this.orderdetailData = data
			this.showClearPage = true
		},
		submitClear(data) {
			let form = new FormData()
			form.append('ID', this.orderdetailData.ID)
			form.append('PlanTrust', data.type == 1 ? 'market' : 'limit')
			form.append('PlanTrustNum', data.number)
			form.append('PlanTrustPrice', data.price)
			if (this.isModal) {
				imitateContractLiquidation(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success3'))
						this.showClearPage = false
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			} else {
				contractLiquidation(form).then(res => {
					if (res.code == 0) {
						this.$toast.success(this.i18n.t('trade.success3'))
						this.showClearPage = false
						this.initOrder()
					} else {
						this.$toast.fail(res.msg)
					}
				})
			}
		},
		searchMarket() {
      if (!this.keyword) {
        if (this.isSearch) {
          this.clearSearch()
        }
        return
      }
      this.finished = true
      this.isSearch = true
      this.marketList = this.bitList.filter(v => {
        return v.ShortName.toLowerCase().indexOf(this.keyword) > -1
      })
    },
    clearSearch() {
      this.isSearch = false
      this.finished = false
      this.marketList = [].concat(this.bitList)
    },
		resetBitMoney(money) {
			// let rate = 1
			// let index = this.allRateList.findIndex(v => {
			// 	return v.Name == this.bitInfo.ShortName
			// })
			// if (index > -1) {
			// 	rate = this.allRateList[index].Rate
			// }
			// return (money * rate).toFixed(4)
			return (money * this.bitInfo.count).toFixed(4)
		},
		resetBitMoney2(money) {
			let rate = 1
			const rateList = Array.isArray(this.allRateList) ? this.allRateList : []
			let index = rateList.findIndex(v => {
				return v.Name == this.currencyVal
			})
			if (index > -1) {
				rate = rateList[index].Rate
			}
			return (money * rate).toFixed(4)
		},
		toTransfer() {
			let type = 1
			if (this.pageType == 2) {//期权
				type = 2
			} else if (this.pageType == 3) {//合约
				type = 3
			} else if (this.pageType == 1) {//现货
				type = 4
			} else if (this.isModal && this.modalType == 1) { // 模拟期权
				type = 2
			} else if (this.isModal && this.modalType == 2) { // 模拟合约
				type = 3
			}
			this.$router.push({
				name: 'transfer',
				query: {
					type: type
				}
			})
		},
		getContractClose(close, multiple, type) {
			if (type == 'long') {
				return parseFloat((close * (1 - 1 / multiple)).toFixed(4))
			} else {
				return parseFloat((close * (1 + 1 / multiple)).toFixed(4))
			}
		},
		formatOrderTime(time) {
			return formatServerTimeEn(time, 'hh:mm:ss A')
		},
    getCountdown(item) {
      if(item.Status !== 0) return item.Settlement;

      // 检查Settlement是否为有效数值
      const settlement = parseInt(item.Settlement, 10);
      if (isNaN(settlement) || settlement <= 0) {
        console.error('Invalid Settlement value:', item.Settlement);
        return 0;
      }

      try {
        // 获取服务器时区，默认为 Asia/Shanghai
        const serverTimezone = this.$store.state.timeZone || 'Asia/Shanghai';

        // 创建服务器时间（服务器返回的时间是服务器时区的时间）
        const createdAt = moment.tz(item.CreatedAt, serverTimezone);
        // 获取当前服务器时区的时间（基于服务器时间偏移）
        const currentTime = getServerNow();

        // 检查创建时间是否有效
        if (!createdAt.isValid()) {
          console.error('Invalid CreatedAt date:', item.CreatedAt);
          return 0;
        }

        // 计算已经过的秒数（使用服务器时区统一计算）
        const elapsedSeconds = Math.floor(currentTime.diff(createdAt) / 1000);

        // 如果已过时间为负数（可能是服务器时间与本地时间不同步），则返回完整时间
        if (elapsedSeconds < 0) {
          console.warn('Time difference is negative, possible server-client time mismatch', {
            createdAt: item.CreatedAt,
            serverTime: currentTime.format('YYYY-MM-DD HH:mm:ss'),
            localTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            diff: elapsedSeconds,
            timezone: serverTimezone
          });
          return settlement;
        }

        // 计算剩余秒数 = 总结算秒数 - 已经过秒数
        const remainingSeconds = settlement - elapsedSeconds;

        // 日志记录用于调试
        if (remainingSeconds <= 0) {
          console.log('Countdown completed', {
            id: item.ID,
            createdAt: item.CreatedAt,
            serverTime: currentTime.format('YYYY-MM-DD HH:mm:ss'),
            localTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            elapsed: elapsedSeconds,
            settlement: settlement,
            remaining: remainingSeconds,
            timezone: serverTimezone
          });
        }

        // 确保不小于0
        return Math.max(0, remainingSeconds);
      } catch (error) {
        console.error('Error calculating countdown:', error);
        return 0;
      }
    },
    setupCountdownInterval() {
      // 每500ms更新一次倒计时
      this.clearCountdownInterval(); // 先清除现有的

      this.countdownInterval = setInterval(() => {
        if(this.tabIndex === 2) { // 只在期权订单页面更新
          this.$forceUpdate(); // 强制视图更新
        }
      }, 500);
    },
    clearCountdownInterval() {
      if(this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
		startCountdownTimer() {
			// 清除已有的定时器
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
			}

			this.countdownTimer = setInterval(() => {
				// 只需要触发视图更新，让getCountdown重新计算倒计时
				this.$forceUpdate();
			}, 1000);
		},
		detectOrderStatusChange(items) {
			// 检测订单状态变化，当订单从Status == 0变成其他状态时，添加到保留列表
			items.forEach(item => {
				// 如果订单已经结算且不在保留列表中，检查是否需要添加到保留列表
				if (item.Status !== 0 && !this.retainedOrderIds.includes(item.ID)) {
					// 检查这个订单之前是否存在于当前订单列表中且状态为0
					const existingOrder = this.optionOrderArr.find(existingItem => existingItem.ID === item.ID)
					if (existingOrder && existingOrder.Status === 0) {
						// 订单状态发生了变化（从进行中变为已结算），添加到保留列表
						this.retainedOrderIds.push(item.ID)
						this.retainedOrderTimestamps[item.ID] = getServerNow().valueOf()
						console.log(`订单 ${item.ID} 从未结算状态变为已结算，保留在当前订单列表中5分钟`)
					}
				}

				// 如果订单状态变回0（重新开始），从保留列表中移除
				if (item.Status === 0 && this.retainedOrderIds.includes(item.ID)) {
					const index = this.retainedOrderIds.indexOf(item.ID)
					this.retainedOrderIds.splice(index, 1)
					delete this.retainedOrderTimestamps[item.ID]
					console.log(`订单 ${item.ID} 状态变回未结算，从保留列表中移除`)
				}
			})
		},
		cleanExpiredRetainedOrders() {
			// 清理超过5分钟的保留订单
			const currentTime = getServerNow().valueOf()
			const initialLength = this.retainedOrderIds.length

			this.retainedOrderIds = this.retainedOrderIds.filter(id => {
				const timestamp = this.retainedOrderTimestamps[id]
				if (timestamp && currentTime - timestamp > 5 * 60 * 1000) { // 5分钟过期
					delete this.retainedOrderTimestamps[id]
					console.log(`订单 ${id} 保留时间已过期，从当前订单列表中移除`)
					return false
				}
				return true
			})

			if (this.retainedOrderIds.length !== initialLength) {
				console.log(`清理了 ${initialLength - this.retainedOrderIds.length} 个过期的保留订单`)
			}
		},
		isRetainedOrder(orderId) {
			// 检查订单是否在保留列表中
			return this.retainedOrderIds.includes(orderId)
		},
		getRetainedOrderRemainingTime(orderId) {
			// 获取保留订单的剩余时间（秒）
			const timestamp = this.retainedOrderTimestamps[orderId]
			if (!timestamp) return 0

			const currentTime = getServerNow().valueOf()
			const elapsed = currentTime - timestamp
			const remaining = (5 * 60 * 1000) - elapsed // 5分钟总时长

			return Math.max(0, Math.floor(remaining / 1000))
		},
		initHistoryOrder() {
			// 获取历史订单
			if (!getToken()) {
				return
			}
			clearTimeout(this.orderTimer)

			let form = new FormData()
			form.append('current', 1)
			form.append('pageSize', 20)
			// 历史订单：用近 30 天的本地时间宽窗口（与 PC 端一致），不再用"当天"窗口。
			// "当天"窗口依赖前端推算的服务器时区，时区/时钟不一致时会漏掉跨天边界的已结算单；
			// 30 天宽窗口对小时级时区/时钟偏差免疫，配合服务端 id desc 分页足够覆盖近期历史。
			form.append('Start', moment().subtract(30, 'days').format('YYYY-MM-DD') + ' 00:00:00')
			form.append('End', moment().format('YYYY-MM-DD') + ' 23:59:59')

			if (this.isModal) {
				imitateOptionOrderList(form).then(res => {
					// 过滤出已完成的历史订单（状态不为0的订单）
					this.historyOptionOrderArr = res.data.Items.filter(item => item.Status !== 0)
					this.orderTimer = setTimeout(() => {
						this.initHistoryOrder()
					}, 10000) // 历史订单更新频率较低
				})
			} else {
				optionOrderList(form).then(res => {
					// 过滤出已完成的历史订单（状态不为0的订单）
					this.historyOptionOrderArr = res.data.Items.filter(item => item.Status !== 0)
					this.orderTimer = setTimeout(() => {
						this.initHistoryOrder()
					}, 10000) // 历史订单更新频率较低
				})
			}
		},
  },
}
</script>
<style lang="less">
.countdown {
  color: #F7A600;
  font-weight: bold;
}
.settling {
  color: #F7A600;
  font-weight: bold;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.option-skeleton,
.option-skeleton-text {
  position: relative;
  overflow: hidden;
  background: #d8eee5;
  pointer-events: none;
}

.option-skeleton {
  color: transparent;
}

.option-skeleton-text {
  width: 110px;
  height: 18px;
  border-radius: 4px;
}

.option-skeleton::after,
.option-skeleton-text::after {
  content: "";
  position: absolute;
  top: 0;
  left: -80%;
  width: 80%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0));
  animation: optionSkeletonShimmer 1.1s ease-in-out infinite;
}

@keyframes optionSkeletonShimmer {
  from {
    left: -80%;
  }
  to {
    left: 120%;
  }
}

/* 保留订单样式 */
.retained-order {
  background-color: rgba(247, 166, 0, 0.08) !important;
  border-left: 2px solid #F7A600;
  animation: fadeIn 0.5s ease-in-out;
}

.retained-label {
  background-color: rgba(247, 166, 0, 0.2);
  color: #F7A600;
  font-size: 11px;
  padding: 0 4px;
  border-radius: 2px;
  margin-left: 4px;
  font-weight: 500;
  height: 20px;
  line-height: 20px;
  min-width: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
